export default {
    // 中
    zhCN: {
        factory: '工厂',
        vehicle_platform: '车型平台',
        model_year: '车型年',
        order_no: '订单号',
        order_type: '订单类型',
        vehicle_material_no: '整车物料号',
        engine_no: '发动机序列号',
        certificate_no_14: '14位合格证号',
        certificate_no_15: '15位合格证号',
        certificate_date: '合格证打印日期',
        pn: 'PIN',
        uptime: '总装上线时间',
        end_time: '车辆生产结束时间',
        bomversion: 'BOMVERSION',
        product_code: '生产代码',
        industrial_division: '⽣产区分(CKD、SKD、CBU)',
        vehicle_material_number_description: '整车物料号描述',
        SAIC_order_number: '上汽国际订单号',
        station_code: '工厂代码',
        station_desc: '工厂描述',
        station_number: '工位编号',
        station_name: '工位名称',
        vehicle_arrival_time: '车辆到达时间',
        key_component_barcode: '关键件条码',
        scan_time: '扫描时间',
        key_component_type_code: '关键件类型编码',
        key_component_type_desc: '关键件类型描述(中文)',
        key_component_type_descen: '关键件类型描述(英文)',
        part_number: '零件号',
        supplier_name: '供应商号',
        traceability_number: '追溯号',
        subcritical_component_type: '子关键件类型',
        batch_number: '批次号',
        vehicle_base_info: '车辆基础信息',
        vehicle_crossing_data: '车辆过点数据',
        accurately_traceable_parts_list: '精确追溯零件清单',
        vehicle_configuration_information: '车辆配置信息',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP 特征 ID',
        SAP_feature_Codes: 'SAP 特征码',
        SAP_feature_Description: 'SAP 特征描述',
        SAP_feature_value_Description: 'SAP 特征值描述',
        SAP_feature_Description_EN: 'SAP 特征描述(英文)',
        SAP_feature_value_Description_EN: 'SAP 特征值描述(英文)',
        batteryNo: '电池编号',
        qmotorNo: '前电机编号',
        hmotorNo: '后电机编号',
        feature_ID: '特征ID',
        feature_Description: '特征描述(中文)',
        feature_Description_EN: '特征描述(英文)',
        feature_Codes: '特征码',
        feature_value_Description: '特征值描述(中文)',
        feature_value_Description_EN: '特征值描述(英文)',
        description_zh: '中文描述',
        supplier: '供应商',
        barCoding: '条形编码',
        key_component_type_desc_En: '关键件类型描述(英文)',
        partName: '零件中文名称',
        partName_En: '零件英文名称',
        workstation_code: '工位代码',
        workstationDesc: '工位描述(中文)',
        workstationDesc_En: '工位描述(英文)',
        packageNo: '电池包编码',
        packageType: '电池包型号',
        moduleNo: '电池模组编码',
        moduleType: '模组型号',
        cellNo: '单体电池编码',
        cellModelId: '单体型号',
        uploadTime: '报送时间',
        vehicle_battery_data: '车辆精追电池数据',
    },
    // 英
    enUS: {
        factory: 'Factory',
        vehicle_platform: 'Vehicle platform',
        model_year: 'Model year',
        order_no: 'Order no',
        order_type: 'Order type',
        vehicle_material_no: 'Vehicle material no',
        engine_no: 'Engine no',
        certificate_no_14: 'Certificate no 14',
        certificate_no_15: 'Certificate no 15',
        certificate_date: 'Certificate date',
        pn: 'PIN',
        uptime: 'Final assembly launch time',
        end_time: 'Vehicle production end time',
        bomversion: 'BOMVERSION',
        product_code: 'Product code',
        industrial_division: 'Industrial division(CKD、SKD、CBU)',
        vehicle_material_number_description: 'Vehicle material number description',
        SAIC_order_number: 'SAIC International Order Number',
        station_code: 'Factory code',
        station_desc: 'Factory Description',
        station_number: 'Station number',
        station_name: 'Station name',
        vehicle_arrival_time: 'Vehicle arrival time',
        key_component_barcode: 'Key component barcode',
        scan_time: 'Scan time',
        key_component_type_code: 'Key component type code',
        key_component_type_desc: 'Key Component Type Description (Chinese)',
        key_component_type_descen: 'Key Component Type Description (English)',
        part_number: 'Part number',
        supplier_name: 'Supplier Name',
        traceability_number: 'Traceability number',
        subcritical_component_type: 'Subcritical component type',
        batch_number: 'Batch number',
        vehicle_base_info: 'Vehicle basic information',
        vehicle_crossing_data: 'Vehicle crossing data',
        accurately_traceable_parts_list: 'Accurately Traceable Parts List',
        vehicle_configuration_information: 'Vehicle configuration information',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP feature ID',
        SAP_feature_Codes: 'SAP feature codes',
        SAP_feature_Description: 'SAP feature description',
        SAP_feature_value_Description: 'SAP feature value description',
        SAP_feature_Description_EN: 'SAP feature description(English)',
        SAP_feature_value_Description_EN: 'SAP feature value description(English)',
        batteryNo: 'Battery Number',
        qmotorNo: 'Front Motor Number',
        hmotorNo: 'Rear Motor Number',
        feature_ID: 'Feature ID',
        feature_Description: 'Feature Description (Chinese)',
        feature_Description_EN: 'Feature Description (English)',
        feature_Codes: 'Feature Codes',
        feature_value_Description: 'Feature Value Description (Chinese)',
        feature_value_Description_EN: 'Feature Value Description (English)',
        description_zh: 'Description (Chinese)',
        supplier: 'Supplier',
        barCoding: 'Bar Coding',
        key_component_type_desc_En: 'Key Component Type Description (English)',
        partName: 'Part Name (Chinese)',
        partName_En: 'Part Name (English)',
        workstation_code: 'Workstation Code',
        workstationDesc: 'Workstation Description (Chinese)',
        workstationDesc_En: 'Workstation Description (English)',
        packageNo: 'Battery Pack Code',
        packageType: 'Battery Pack Model',
        moduleNo: 'Battery Module Code',
        moduleType: 'Module Model',
        cellNo: 'Single Cell Code',
        cellModelId: 'Single Cell Model',
        uploadTime: 'Upload Time',
        vehicle_battery_data: 'Vehicle Battery Data',
    },
    // 德
    deDE: {
        factory: 'Fabrik',
        vehicle_platform: 'Fahrzeugplattform',
        model_year: 'Modelljahr',
        order_no: 'Bestellnummer',
        order_type: 'Auftragsart',
        vehicle_material_no: 'Fahrzeugmaterialnummer',
        engine_no: 'Seriennummer des Motors',
        certificate_no_14: '14-stellige Zertifikatsnummer',
        certificate_no_15: '15-stellige Zertifikatsnummer',
        certificate_date: 'Datum des Ausdrucks der Bescheinigung',
        pn: 'PIN',
        uptime: 'Startzeit der Endmontage',
        end_time: 'Endzeit der Fahrzeugproduktion',
        bomversion: 'BOMVERSION',
        product_code: 'Produktionscode',
        industrial_division: '⽣Industriebereich(CKD、SKD、CBU)',
        vehicle_material_number_description: 'Beschreibung der Fahrzeugmaterialnummer',
        SAIC_order_number: 'SAIC International Bestellnummer',
        station_code: 'Fabrikcode',
        station_desc: 'Fabrikbeschreibung',
        station_number: 'Bahnhofsnummer',
        station_name: 'Name der Station',
        vehicle_arrival_time: 'Ankunftszeit des Fahrzeugs',
        key_component_barcode: 'Barcode der Hauptkomponente',
        scan_time: 'Scanzeit',
        key_component_type_code: 'Schlüsselkomponententypcode',
        key_component_type_desc: 'Beschreibung des Schlüsselkomponententyps (Chinesisch)',
        key_component_type_descen: 'Beschreibung des Schlüsselkomponententyps (Englisch)',
        part_number: 'Teilenummer',
        supplier_name: 'Name des Lieferanten',
        traceability_number: 'Rückverfolgbarkeitsnummer',
        subcritical_component_type: 'Subkritischer Komponententyp',
        batch_number: 'Chargennummer',
        vehicle_base_info: 'Grundlegende Fahrzeuginformationen',
        vehicle_crossing_data: 'Daten zur Fahrzeugüberquerung',
        accurately_traceable_parts_list: 'Genau nachvollziehbare Teileliste',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP Funktions-ID',
        SAP_feature_Codes: 'SAP Funktionscodes',
        SAP_feature_Description: 'SAP Funktionsbeschreibung',
        SAP_feature_value_Description: 'SAP Funktionswertbeschreibung',
        SAP_feature_Description_EN: 'SAP Funktionsbeschreibung(Englisch)',
        SAP_feature_value_Description_EN: 'SAP Funktionswertbeschreibung(Englisch)',
        batteryNo: 'Hintere Motornummer',
        qmotorNo: 'Front Motor Number',
        hmotorNo: 'Rear Motor Number',
        feature_ID: 'Merkmal-ID',
        feature_Description: 'Merkmalsbeschreibung (Chinesisch)',
        feature_Description_EN: 'Merkmalsbeschreibung (Englisch)',
        feature_Codes: 'Merkmalscodes',
        feature_value_Description: 'Merkmalswertbeschreibung (Chinesisch)',
        feature_value_Description_EN: 'Merkmalswertbeschreibung (Englisch)',
        description_zh: 'Beschreibung (Chinesisch)',
        supplier: 'Lieferant',
        barCoding: 'Strichkodierung',
        key_component_type_desc_En: 'Beschreibung des Schlüsselkomponenten-Typs (Englisch)',
        partName: 'Teilename (Chinesisch)',
        partName_En: 'Teilename (Englisch)',
        workstation_code: 'Arbeitsplatzcode',
        workstationDesc: 'Arbeitsplatzbeschreibung (Chinesisch)',
        workstationDesc_En: 'Arbeitsplatzbeschreibung (Englisch)',
        packageNo: 'Batteriepackcode',
        packageType: 'Batteriepackmodell',
        moduleNo: 'Batteriemodulcode',
        moduleType: 'Modell des Moduls',
        cellNo: 'Einzelzellen-Code',
        cellModelId: 'Einzelzellenmodell',
        uploadTime: 'Übermittlungszeit',
        vehicle_battery_data: 'Fahrzeugbatteriedaten',
    },
    // 法
    frFR: {
        factory: 'Usine',
        vehicle_platform: 'Plate - forme de modèle de voiture',
        model_year: 'Année modèle',
        order_no: 'Numéro de commande',
        order_type: 'Type d\'ordre',
        vehicle_material_no: 'Numéro de matériau du véhicule entier',
        engine_no: 'Numéro de série du moteur',
        certificate_no_14: 'Numéro de certificat de conformité à 14 Chiffres',
        certificate_no_15: 'Numéro de certificat de conformité à 15 Chiffres',
        certificate_date: 'Date d\'impression du certificat de conformité',
        pn: 'PIN',
        uptime: 'Temps de montage final en ligne',
        end_time: 'Temps de fin de production du véhicule',
        bomversion: 'BOMVERSION',
        product_code: 'Code de production',
        industrial_division: 'Différenciation de la production(CKD、SKD、CBU)',
        vehicle_material_number_description: 'Numéro de matériau du véhicule complet Description',
        SAIC_order_number: 'SAIC International numéro de commande',
        station_code: 'Code d\'usine',
        station_desc: 'Description de l\'usine',
        station_number: 'Numéro de station',
        station_name: 'Nom de la station',
        vehicle_arrival_time: 'Heure d\'arrivée du véhicule',
        key_component_barcode: 'Code à barres des pièces clés',
        scan_time: 'Temps de scan',
        key_component_type_code: 'Codage des types de pièces clés',
        key_component_type_desc: 'Description du type de composant clé (chinois)',
        key_component_type_descen: 'Description du type de composant clé (anglais)',
        part_number: 'Numéro de pièce',
        supplier_name: 'Nom du fournisseur',
        traceability_number: 'Numéro de rétroactivité',
        subcritical_component_type: 'Type de sous - clé',
        batch_number: 'Numéro de lot',
        vehicle_base_info: 'Informations de base sur le véhicule',
        vehicle_crossing_data: 'Données de dépassement de véhicule',
        accurately_traceable_parts_list: 'Liste de pièces de traçabilité précise',
        VIN: 'VIN',
        SAP_feature_ID: 'Identifiant de fonction SAP',
        SAP_feature_Codes: 'Codes de fonction SAP',
        SAP_feature_Description: 'Description de fonction SAP',
        SAP_feature_value_Description: 'Description de la valeur de fonction SAP',
        SAP_feature_Description_EN: 'Description de fonction SAP(anglais)',
        SAP_feature_value_Description_EN: 'Description de la valeur de fonction SAP(anglais)',
        batteryNo: 'Numéro de batterie',
        qmotorNo: 'Numéro de moteur avant',
        hmotorNo: 'Numéro de moteur arrière',
        feature_ID: 'ID de Caractéristique',
        feature_Description: 'Description de la Caractéristique (Chinois)',
        feature_Description_EN: 'Description de la Caractéristique (Anglais)',
        feature_Codes: 'Codes de Caractéristique',
        feature_value_Description: 'Description de la Valeur de la Caractéristique (Chinois)',
        feature_value_Description_EN: 'Description de la Valeur de la Caractéristique (Anglais)',
        description_zh: 'Description (Chinois)',
        supplier: 'Fournisseur',
        barCoding: 'Codage à Barres',
        key_component_type_desc_En: 'Description du Type de Composant Clé (Anglais)',
        partName: 'Nom de la Pièce (Chinois)',
        partName_En: 'Nom de la Pièce (Anglais)',
        workstation_code: 'Code du Poste de Travail',
        workstationDesc: 'Description du Poste de Travail (Chinois)',
        workstationDesc_En: 'Description du Poste de Travail (Anglais)',
        packageNo: 'Code du Pack de Batterie',
        packageType: 'Modèle de Pack de Batterie',
        moduleNo: 'Code du Module de Batterie',
        moduleType: 'Modèle de Module',
        cellNo: 'Code de la Cellule Unique',
        cellModelId: 'Modèle de Cellule Unique',
        uploadTime: 'Heure de Téléchargement',
        vehicle_battery_data: 'Données de Batterie de Véhicule',
    },
    // 意大利
    itIT: {
        factory: 'Fabbrica',
        vehicle_platform: 'Piattaforma del veicolo',
        model_year: 'Anno modello',
        order_no: 'Numero d\'ordine',
        order_type: 'Tipo di ordine',
        vehicle_material_no: 'Numero materiale del veicolo',
        engine_no: 'Numero di serie del motore',
        certificate_no_14: 'Numero di certificato a 14 cifre',
        certificate_no_15: 'Numero di certificato a 15 cifre',
        certificate_date: 'Data di stampa del certificato',
        pn: 'PIN',
        uptime: 'Tempo di lancio finale dell\'assemblaggio',
        end_time: 'Fine produzione del veicolo',
        bomversion: 'BOMVERSION',
        product_code: 'Codice di produzione',
        industrial_division: 'Differenziamento della produzione(CKD、SKD、CBU)',
        vehicle_material_number_description: 'Descrizione del numero del materiale del veicolo',
        SAIC_order_number: 'Numero d\'ordine internazionale SAIC',
        station_code: 'Codice azienda',
        station_desc: 'Descrizione dell\'azienda',
        station_number: 'Numero della stazione',
        station_name: 'Nome della stazione',
        vehicle_arrival_time: 'Orario di arrivo del veicolo',
        key_component_barcode: 'Codice a barre del componente chiave',
        scan_time: 'Tempo di scansione',
        key_component_type_code: 'Codice del tipo di componente chiave',
        key_component_type_desc: 'Descrizione del tipo di componente chiave (cinese)',
        key_component_type_descen: 'Descrizione del tipo di componente chiave (inglese)',
        part_number: 'Numero di parte',
        supplier_name: 'Nome fornitore',
        traceability_number: 'Numero di rintracciabilità',
        subcritical_component_type: 'Tipo di componente sottocritico',
        batch_number: 'Numero di lotto',
        vehicle_base_info: 'Informazioni di base del veicolo',
        vehicle_crossing_data: 'Dati di attraversamento del veicolo',
        accurately_traceable_parts_list: 'Elenco parti tracciabili con precisione',
        VIN: 'VIN',
        SAP_feature_ID: 'ID funzione SAP',
        SAP_feature_Codes: 'Codici funzione SAP',
        SAP_feature_Description: 'Descrizione funzione SAP',
        SAP_feature_value_Description: 'Descrizione del valore di funzione SAP',
        SAP_feature_Description_EN: 'Descrizione funzione SAP(inglese)',
        SAP_feature_value_Description_EN: 'Descrizione del valore di funzione SAP(inglese)',
        batteryNo: 'Numero della batteria',
        qmotorNo: 'Numero motore anteriore',
        hmotorNo: 'Numero motore posteriore',
        feature_ID: 'ID Caratteristica',
        feature_Description: 'Descrizione Caratteristica (Cinese)',
        feature_Description_EN: 'Descrizione Caratteristica (Inglese)',
        feature_Codes: 'Codici Caratteristica',
        feature_value_Description: 'Descrizione Valore Caratteristica (Cinese)',
        feature_value_Description_EN: 'Descrizione Valore Caratteristica (Inglese)',
        description_zh: 'Descrizione (Cinese)',
        supplier: 'Fornitore',
        barCoding: 'Codifica a Barre',
        key_component_type_desc_En: 'Descrizione Tipo Componente Chiave (Inglese)',
        partName: 'Nome Parte (Cinese)',
        partName_En: 'Nome Parte (Inglese)',
        workstation_code: 'Codice Postazione di Lavoro',
        workstationDesc: 'Descrizione Postazione di Lavoro (Cinese)',
        workstationDesc_En: 'Descrizione Postazione di Lavoro (Inglese)',
        packageNo: 'Codice Pacco Batteria',
        packageType: 'Modello Pacco Batteria',
        moduleNo: 'Codice Modulo Batteria',
        moduleType: 'Modello Modulo',
        cellNo: 'Codice Singola Cellula',
        cellModelId: 'Modello Singola Cellula',
        uploadTime: 'Orario di Caricamento',
        vehicle_battery_data: 'Dati della Batteria del Veicolo',
    },
    // 荷兰
    nlNL: {
        factory: 'Fabriek',
        vehicle_platform: 'Voertuigplatform',
        model_year: 'Modeljaar',
        order_no: 'Ordernummer',
        order_type: 'Ordertype',
        vehicle_material_no: 'Materiaal nummer van het voertuig',
        engine_no: 'Serienummer van de motor',
        certificate_no_14: '14-cijferig certificaatnummer',
        certificate_no_15: '15-cijferig certificaatnummer',
        certificate_date: 'Datum van afdrukken van het certificaat',
        pn: 'PIN',
        uptime: 'Eindmontagetijd',
        end_time: 'Eindtijd voertuigproductie',
        bomversion: 'BOMVERSION',
        product_code: 'Productiecode',
        industrial_division: 'Productieverschilling(CKD、SKD、CBU)',
        vehicle_material_number_description: 'Beschrijving van het voertuigmateriaalnummer',
        SAIC_order_number: 'SAIC International Order Number',
        station_code: 'Fabriekscode',
        station_desc: 'Fabrieksomschrijving',
        station_number: 'Stationummer',
        station_name: 'Stationaam',
        vehicle_arrival_time: 'Aankomst van het voertuig',
        key_component_barcode: 'Strijkcode voor sleutelcomponenten',
        scan_time: 'Scantijd',
        key_component_type_code: 'Type sleutelcomponent',
        key_component_type_desc: 'Beschrijving van het type sleutelcomponent (Chinees)',
        key_component_type_descen: 'Beschrijving van het type sleutelcomponent (Engels)',
        part_number: 'onderdeelnummer',
        supplier_name: 'Naam van de leverancier',
        traceability_number: 'Traceerbaarheidsnummer',
        subcritical_component_type: 'Subkritisch componenttype',
        batch_number: 'Batchnummer',
        vehicle_base_info: 'Basisinformatie over het voertuig',
        vehicle_crossing_data: 'Gegevens over het oversteken van voertuigen',
        accurately_traceable_parts_list: 'Nauwkeurig traceerbare onderdelenlijst',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP-functie-ID',
        SAP_feature_Codes: 'SAP-functiecodes',
        SAP_feature_Description: 'SAP-functiebeschrijving',
        SAP_feature_value_Description: 'SAP-functiewaardebeschrijving',
        SAP_feature_Description_EN: 'SAP-functiebeschrijving(Engels)',
        SAP_feature_value_Description_EN: 'SAP-functiewaardebeschrijving(Engels)',
        batteryNo: 'Batterijnummer',
        qmotorNo: 'Voorste motornummer',
        hmotorNo: 'Achterste motornummer',
        feature_ID: 'Kenmerk-ID',
        feature_Description: 'Kenmerkbeschrijving (Chinees)',
        feature_Description_EN: 'Kenmerkbeschrijving (Engels)',
        feature_Codes: 'Kenmerkcodes',
        feature_value_Description: 'Kenmerkwaardebeschrijving (Chinees)',
        feature_value_Description_EN: 'Kenmerkwaardebeschrijving (Engels)',
        description_zh: 'Beschrijving (Chinees)',
        supplier: 'Leverancier',
        barCoding: 'Streepjescode',
        key_component_type_desc_En: 'Beschrijving van het Type Sleutelcomponent (Engels)',
        partName: 'Onderdeelnaam (Chinees)',
        partName_En: 'Onderdeelnaam (Engels)',
        workstation_code: 'Werkstationcode',
        workstationDesc: 'Beschrijving van het Werkstation (Chinees)',
        workstationDesc_En: 'Beschrijving van het Werkstation (Engels)',
        packageNo: 'Batterijpakketcode',
        packageType: 'Batterijpakketmodel',
        moduleNo: 'Batterijmodulecode',
        moduleType: 'Modulemodel',
        cellNo: 'Enkelvoudige Celcode',
        cellModelId: 'Enkelvoudig Celmodel',
        uploadTime: 'Uploadtijd',
        vehicle_battery_data: 'Voertuigbatterijgegevens',
    },
    // 越南
    viVN: {
        factory: 'Nhà máy',
        vehicle_platform: 'Nền tảng mô hình',
        model_year: 'Mô hình năm',
        order_no: 'Số thứ tự',
        order_type: 'Loại lệnh',
        vehicle_material_no: 'Số nguyên liệu xe',
        engine_no: 'Số sê-ri động cơ',
        certificate_no_14: '14 Số chứng nhận hợp lệ',
        certificate_no_15: '15 Số chứng nhận hợp lệ',
        certificate_date: 'Ngày in giấy chứng nhận hợp lệ',
        pn: 'PIN',
        uptime: 'Tổng thời gian cài đặt',
        end_time: 'Thời gian kết thúc sản xuất xe',
        bomversion: 'BOMVERSION',
        product_code: 'Mã sản xuất',
        industrial_division: 'Phân biệt sản xuất(CKD、SKD、CBU)',
        vehicle_material_number_description: 'Toàn bộ xe Vật liệu No Description',
        SAIC_order_number: 'Số đặt hàng quốc tế SAIC',
        station_code: 'Mã nhà máy',
        station_desc: 'Mô tả nhà máy',
        station_number: 'Số trạm',
        station_name: 'Tên trạm',
        vehicle_arrival_time: 'Thời gian xe đến',
        key_component_barcode: 'Mã vạch Key Piece',
        scan_time: 'Thời gian quét',
        key_component_type_code: 'Mã hóa kiểu phần chính',
        key_component_type_desc: 'Mô tả loại thành phần chính (Tiếng Trung)',
        key_component_type_descen: 'Mô tả loại thành phần chính (Tiếng Anh)',
        part_number: 'Phần số',
        supplier_name: 'Số nhà cung cấp',
        traceability_number: 'Số truy xuất',
        subcritical_component_type: 'Loại khóa con',
        batch_number: 'Số lô',
        vehicle_base_info: 'Thông tin cơ bản về xe',
        vehicle_crossing_data: 'Xe vượt qua dữ liệu',
        accurately_traceable_parts_list: 'Danh sách phần truy xuất chính xác',
        VIN: 'VIN',
        SAP_feature_ID: 'ID tính năng SAP',
        SAP_feature_Codes: 'Mã tính năng SAP',
        SAP_feature_Description: 'Mô tả tính năng SAP',
        SAP_feature_value_Description: 'Mô tả giá trị tính năng SAP',
        SAP_feature_Description_EN: 'Mô tả tính năng SAP(Tiếng Anh)',
        SAP_feature_value_Description_EN: 'Mô tả giá trị tính năng SAP(Tiếng Anh)',
        batteryNo: 'Số pin',
        qmotorNo: 'Số máy trước',
        hmotorNo: 'Số máy sau',
        feature_ID: 'ID Tính năng',
        feature_Description: 'Mô tả Tính năng (Tiếng Trung)',
        feature_Description_EN: 'Mô tả Tính năng (Tiếng Anh)',
        feature_Codes: 'Mã Tính năng',
        feature_value_Description: 'Mô tả Giá trị Tính năng (Tiếng Trung)',
        feature_value_Description_EN: 'Mô tả Giá trị Tính năng (Tiếng Anh)',
        description_zh: 'Mô tả (Tiếng Trung)',
        supplier: 'Nhà cung cấp',
        barCoding: 'Mã Vạch',
        key_component_type_desc_En: 'Mô tả Loại Thành phần Chính (Tiếng Anh)',
        partName: 'Tên Bộ phận (Tiếng Trung)',
        partName_En: 'Tên Bộ phận (Tiếng Anh)',
        workstation_code: 'Mã Trạm Làm việc',
        workstationDesc: 'Mô tả Trạm Làm việc (Tiếng Trung)',
        workstationDesc_En: 'Mô tả Trạm Làm việc (Tiếng Anh)',
        packageNo: 'Mã Gói Pin',
        packageType: 'Mẫu Gói Pin',
        moduleNo: 'Mã Mô-đun Pin',
        moduleType: 'Mẫu Mô-đun',
        cellNo: 'Mã Tế bào Đơn',
        cellModelId: 'Mẫu Tế bào Đơn',
        uploadTime: 'Thời gian Tải lên',
        vehicle_battery_data: 'Dữ Liệu Pin Xe',
    },
    // 西班牙
    esES: {
        factory: 'Fábrica',
        vehicle_platform: 'Plataforma de modelos',
        model_year: 'Año del modelo',
        order_no: 'Número de pedido',
        order_type: 'Tipo de pedido',
        vehicle_material_no: 'Número de material del vehículo',
        engine_no: 'Número de serie del motor',
        certificate_no_14: 'Número de certificado de 14 plazas',
        certificate_no_15: 'Número de certificado de 15 plazas',
        certificate_date: 'Fecha de impresión del certificado de conformidad',
        pn: 'PIN',
        uptime: 'Tiempo de lanzamiento del montaje final',
        end_time: 'Tiempo de finalización de la producción de vehículos',
        bomversion: 'BOMVERSION',
        product_code: 'Código de producción',
        industrial_division: 'Distinción de producción(CKD、SKD、CBU)',
        vehicle_material_number_description: 'Descripción del número de material del vehículo',
        SAIC_order_number: 'SAIC International Order No.',
        station_code: 'Código de fábrica',
        station_desc: 'Descripción de la fábrica',
        station_number: 'Número de estación',
        station_name: 'Nombre de la estación',
        vehicle_arrival_time: 'Hora de llegada del vehículo',
        key_component_barcode: 'Código de barras de piezas clave',
        scan_time: 'Tiempo de escaneo',
        key_component_type_code: 'Codificación del tipo de pieza clave',
        key_component_type_desc: 'Descripción del tipo de componente clave (chino)',
        key_component_type_descen: 'Descripción del tipo de componente clave (inglés)',
        part_number: 'Número de pieza',
        supplier_name: 'Nombre del proveedor',
        traceability_number: 'Número de trazabilidad',
        subcritical_component_type: 'Tipo de pieza subcrítica',
        batch_number: 'Número de lote',
        vehicle_base_info: 'Información básica del vehículo',
        vehicle_crossing_data: 'Datos del punto de paso del vehículo',
        accurately_traceable_parts_list: 'Trazabilidad precisa de la lista de piezas',
        VIN: 'VIN',
        SAP_feature_ID: 'ID de función SAP',
        SAP_feature_Codes: 'Códigos de función SAP',
        SAP_feature_Description: 'Descripción de función SAP',
        SAP_feature_value_Description: 'Descripción del valor de función SAP',
        SAP_feature_Description_EN: 'Descripción de función SAP(inglés)',
        SAP_feature_value_Description_EN: 'Descripción del valor de función SAP(inglés)',
        batteryNo: 'Número de batería',
        qmotorNo: 'Número de motor delantero',
        hmotorNo: 'Número de motor trasero',
        feature_ID: 'ID de Característica',
        feature_Description: 'Descripción de la Característica (Chino)',
        feature_Description_EN: 'Descripción de la Característica (Inglés)',
        feature_Codes: 'Códigos de Característica',
        feature_value_Description: 'Descripción del Valor de la Característica (Chino)',
        feature_value_Description_EN: 'Descripción del Valor de la Característica (Inglés)',
        description_zh: 'Descripción (Chino)',
        supplier: 'Proveedor',
        barCoding: 'Codificación de Barras',
        key_component_type_desc_En: 'Descripción del Tipo de Componente Clave (Inglés)',
        partName: 'Nombre de la Parte (Chino)',
        partName_En: 'Nombre de la Parte (Inglés)',
        workstation_code: 'Código de Estación de Trabajo',
        workstationDesc: 'Descripción de Estación de Trabajo (Chino)',
        workstationDesc_En: 'Descripción de Estación de Trabajo (Inglés)',
        packageNo: 'Código del Paquete de Batería',
        packageType: 'Modelo del Paquete de Batería',
        moduleNo: 'Código del Módulo de Batería',
        moduleType: 'Modelo del Módulo',
        cellNo: 'Código de la Celda Individual',
        cellModelId: 'Modelo de la Celda Individual',
        uploadTime: 'Hora de Carga',
        vehicle_battery_data: 'Datos de la Batería del Vehículo',
    },
    // 葡萄牙
    ptBR: {
        factory: 'Fábrica',
        vehicle_platform: 'Plataforma do Veículo',
        model_year: 'Ano do Modelo',
        order_no: 'Número do Pedido',
        order_type: 'Tipo de Pedido',
        vehicle_material_no: 'Número de Material do Veículo',
        engine_no: 'Número de Série do Motor',
        certificate_no_14: 'Número de Certificado de 14 dígitos',
        certificate_no_15: 'Número de Certificado de 15 dígitos',
        certificate_date: 'Data de Impressão do Certificado',
        pn: 'PIN',
        uptime: 'Tempo de Montagem Total',
        end_time: 'Hora de Término da Produção do Veículo',
        bomversion: 'Versão BOM',
        product_code: 'Código de Produção',
        industrial_division: 'Divisão Industrial (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Descrição do Número de Material do Veículo',
        SAIC_order_number: 'Número do Pedido SAIC',
        station_code: 'Código da fábrica',
        station_desc: 'Descrição da fábrica',
        station_number: 'Número da Estação',
        station_name: 'Nome da Estação',
        vehicle_arrival_time: 'Hora de Chegada do Veículo',
        key_component_barcode: 'Código de Barras do Componente Chave',
        scan_time: 'Hora de Digitalização',
        key_component_type_code: 'Código do Tipo de Componente Chave',
        key_component_type_desc: 'Descrição do tipo de componente chave (chinês)',
        key_component_type_descen: 'Descrição do tipo de componente chave (inglês)',
        part_number: 'Número da Peça',
        supplier_name: 'Nome do Fornecedor',
        traceability_number: 'Número de Rastreabilidade',
        subcritical_component_type: 'Tipo de Componente Subcrítico',
        batch_number: 'Número do Lote',
        vehicle_base_info: 'Informações Básicas do Veículo',
        vehicle_crossing_data: 'Dados de Passagem do Veículo',
        accurately_traceable_parts_list: 'Lista de Peças Rastreáveis com Precisão',
        VIN: 'VIN',
        SAP_feature_ID: 'ID de recurso SAP',
        SAP_feature_Codes: 'Códigos de recurso SAP',
        SAP_feature_Description: 'Descrição de recurso SAP',
        SAP_feature_value_Description: 'Descrição do valor de recurso SAP',
        SAP_feature_Description_EN: 'Descrição de recurso SAP(inglês)',
        SAP_feature_value_Description_EN: 'Descrição do valor de recurso SAP(inglês)',
        batteryNo: 'Número da bateria',
        qmotorNo: 'Número do motor dianteiro',
        hmotorNo: 'Número do motor traseiro',
        feature_ID: 'ID da Característica',
        feature_Description: 'Descrição da Característica (Chinês)',
        feature_Description_EN: 'Descrição da Característica (Inglês)',
        feature_Codes: 'Códigos da Característica',
        feature_value_Description: 'Descrição do Valor da Característica (Chinês)',
        feature_value_Description_EN: 'Descrição do Valor da Característica (Inglês)',
        description_zh: 'Descrição (Chinês)',
        supplier: 'Fornecedor',
        barCoding: 'Codificação de Barras',
        key_component_type_desc_En: 'Descrição do Tipo de Componente Principal (Inglês)',
        partName: 'Nome da Peça (Chinês)',
        partName_En: 'Nome da Peça (Inglês)',
        workstation_code: 'Código da Estação de Trabalho',
        workstationDesc: 'Descrição da Estação de Trabalho (Chinês)',
        workstationDesc_En: 'Descrição da Estação de Trabalho (Inglês)',
        packageNo: 'Código do Pacote de Bateria',
        packageType: 'Modelo do Pacote de Bateria',
        moduleNo: 'Código do Módulo de Bateria',
        moduleType: 'Modelo do Módulo',
        cellNo: 'Código da Célula Individual',
        cellModelId: 'Modelo da Célula Individual',
        uploadTime: 'Hora de Envio',
        vehicle_battery_data: 'Dados da Bateria do Veículo',
    },
    // 波兰
    plPL: {
        factory: 'Fabryka',
        vehicle_platform: 'Platforma pojazdu',
        model_year: 'Rok modelu',
        order_no: 'Numer zamówienia',
        order_type: 'Typ zamówienia',
        vehicle_material_no: 'Numer materiału pojazdu',
        engine_no: 'Numer seryjny silnika',
        certificate_no_14: 'Numer certyfikatu 14 cyfr',
        certificate_no_15: 'Numer certyfikatu 15 cyfr',
        certificate_date: 'Data wydruku certyfikatu',
        pn: 'PIN',
        uptime: 'Całkowity czas montażu',
        end_time: 'Czas zakończenia produkcji pojazdu',
        bomversion: 'Wersja BOM',
        product_code: 'Kod produktu',
        industrial_division: 'Podział przemysłowy (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Opis numeru materiału pojazdu',
        SAIC_order_number: 'Numer zamówienia SAIC',
        station_code: 'Kod fabryki',
        station_desc: 'Opis fabryki',
        station_number: 'Numer stanowiska',
        station_name: 'Nazwa stanowiska',
        vehicle_arrival_time: 'Czas przybycia pojazdu',
        key_component_barcode: 'Kod kreskowy kluczowego komponentu',
        scan_time: 'Czas skanowania',
        key_component_type_code: 'Kod typu kluczowego komponentu',
        key_component_type_desc: 'Opis typu kluczowego komponentu (chiński)',
        key_component_type_descen: 'Opis typu kluczowego komponentu (angielski)',
        part_number: 'Numer części',
        supplier_name: 'Nazwa dostawcy',
        traceability_number: 'Numer śledzenia',
        subcritical_component_type: 'Typ podkluczowego komponentu',
        batch_number: 'Numer partii',
        vehicle_base_info: 'Podstawowe informacje o pojeździe',
        vehicle_crossing_data: 'Dane przechodzenia pojazdu',
        accurately_traceable_parts_list: 'Lista dokładnie śledzonych części',
        VIN: 'VIN',
        SAP_feature_ID: 'ID funkcji SAP',
        SAP_feature_Codes: 'Kody funkcji SAP',
        SAP_feature_Description: 'Opis funkcji SAP',
        SAP_feature_value_Description: 'Opis wartości funkcji SAP',
        SAP_feature_Description_EN: 'Opis funkcji SAP(angielski)',
        SAP_feature_value_Description_EN: 'Opis wartości funkcji SAP(angielski)',
        batteryNo: 'Numer baterii',
        qmotorNo: 'Numer silnika przedniego',
        hmotorNo: 'Numer silnika tylnego',
        feature_ID: 'ID Cechy',
        feature_Description: 'Opis Cechy (Chiński)',
        feature_Description_EN: 'Opis Cechy (Angielski)',
        feature_Codes: 'Kody Cechy',
        feature_value_Description: 'Opis Wartości Cechy (Chiński)',
        feature_value_Description_EN: 'Opis Wartości Cechy (Angielski)',
        description_zh: 'Opis (Chiński)',
        supplier: 'Dostawca',
        barCoding: 'Kodowanie Kreskowe',
        key_component_type_desc_En: 'Opis Typu Kluczowego Komponentu (Angielski)',
        partName: 'Nazwa Części (Chiński)',
        partName_En: 'Nazwa Części (Angielski)',
        workstation_code: 'Kod Stanowiska Pracy',
        workstationDesc: 'Opis Stanowiska Pracy (Chiński)',
        workstationDesc_En: 'Opis Stanowiska Pracy (Angielski)',
        packageNo: 'Kod Pakietu Baterii',
        packageType: 'Model Pakietu Baterii',
        moduleNo: 'Kod Modułu Baterii',
        moduleType: 'Model Modułu',
        cellNo: 'Kod Pojedynczej Komórki',
        cellModelId: 'Model Pojedynczej Komórki',
        uploadTime: 'Czas Przesyłania',
        vehicle_battery_data: 'Dane Baterii Pojazdu',
    },
    // 土耳其语
    trTR: {
        factory: 'bitki',
        vehicle_platform: 'araç platformu',
        model_year: 'model yılı',
        order_no: 'sipariş numarası',
        order_type: 'Sipariş Türü',
        vehicle_material_no: 'araç malzeme numarası',
        engine_no: 'motor numarası',
        certificate_no_14: '14 rakam sertifikat numarası',
        certificate_no_15: '15 rakam sertifikat numarası',
        certificate_date: 'Sertifikat yazdırma tarihi',
        pn: 'PIN',
        uptime: 'çalışma süresi',
        end_time: 'Araç üretim bitiş zamanı',
        bomversion: 'BOMVERSION',
        product_code: 'ÜRÜN KODU',
        industrial_division: 'üretim ayrı(CKD、SKD、CBU)',
        vehicle_material_number_description: 'araç malzeme numarasi açiklama',
        SAIC_order_number: 'SAIC sipariş numarası',
        station_code: 'Fabrika Kodu',
        station_desc: 'Fabrika Açıklaması',
        station_number: 'İş İstasyonu No.',
        station_name: 'İş istasyonunun adı',
        vehicle_arrival_time: 'Araç geldiği zaman',
        key_component_barcode: 'anahtar bileşen barkodu',
        scan_time: 'tarama süresi',
        key_component_type_code: 'Anahtar bileşen tipi kodu',
        key_component_type_desc: 'Ana Bileşen Türü Açıklaması (Çince)',
        key_component_type_descen: 'Ana Bileşen Türü Açıklaması (İngilizce)',
        part_number: 'parça numarası',
        supplier_name: 'tedari̇kçi̇ numarasi',
        traceability_number: 'geriye dönük sayı',
        subcritical_component_type: 'Alt-kritik bileşen tipi',
        batch_number: 'parti numarası',
        vehicle_base_info: 'Temel Araç Bilgileri',
        vehicle_crossing_data: 'araç geçi̇ş veri̇leri̇',
        accurately_traceable_parts_list: 'doğru bir şekilde izlenebilir parça listesi',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP özellik kimliği',
        SAP_feature_Codes: 'SAP özellik kodları',
        SAP_feature_Description: 'SAP özellik açıklaması',
        SAP_feature_value_Description: 'SAP özellik değeri açıklaması',
        SAP_feature_Description_EN: 'SAP özellik açıklaması(İngilizce)',
        SAP_feature_value_Description_EN: 'SAP özellik değeri açıklaması(İngilizce)',
        batteryNo: 'Batarya Numarası',
        qmotorNo: 'Ön Motor Numarası',
        hmotorNo: 'Arka Motor Numarası',
        feature_ID: 'Özellik Kimliği',
        feature_Description: 'Özellik Açıklaması (Çince)',
        feature_Description_EN: 'Özellik Açıklaması (İngilizce)',
        feature_Codes: 'Özellik Kodları',
        feature_value_Description: 'Özellik Değeri Açıklaması (Çince)',
        feature_value_Description_EN: 'Özellik Değeri Açıklaması (İngilizce)',
        description_zh: 'Açıklama (Çince)',
        supplier: 'Tedarikçi',
        barCoding: 'Barkodlama',
        key_component_type_desc_En: 'Ana Bileşen Türü Açıklaması (İngilizce)',
        partName: 'Parça Adı (Çince)',
        partName_En: 'Parça Adı (İngilizce)',
        workstation_code: 'Çalışma İstasyonu Kodu',
        workstationDesc: 'Çalışma İstasyonu Açıklaması (Çince)',
        workstationDesc_En: 'Çalışma İstasyonu Açıklaması (İngilizce)',
        packageNo: 'Pil Paketi Kodu',
        packageType: 'Pil Paketi Modeli',
        moduleNo: 'Pil Modülü Kodu',
        moduleType: 'Modül Modeli',
        cellNo: 'Tek Hücre Kodu',
        cellModelId: 'Tek Hücre Modeli',
        uploadTime: 'Yükleme Zamanı',
        vehicle_battery_data: 'Araç Batarya Verileri',
    },
    // 捷克语
    csCZ: {
        factory: 'Továrna',
        vehicle_platform: 'Platforma vozidla',
        model_year: 'Modelový rok',
        order_no: 'Objednávka číslo',
        order_type: 'Typ objednávky',
        vehicle_material_no: 'Materiál vozidla č',
        engine_no: 'číslo motoru',
        certificate_no_14: 'Certifikát číslo 14',
        certificate_no_15: 'Certifikát číslo 15',
        certificate_date: 'Datum certifikátu',
        pn: 'Pn',
        uptime: 'Konečný čas montáže',
        end_time: 'Čas ukončení výroby vozidla',
        bomversion: 'BOMVERSION',
        product_code: 'Kód produktu',
        industrial_division: 'Průmyslová divize (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Popis materiálu vozidla',
        SAIC_order_number: 'Číslo mezinárodní objednávky SAIC',
        station_code: 'Kód pracovní stanice',
        station_desc: 'Popis stanice',
        station_number: 'Číslo stanice',
        station_name: 'Název pracovní stanice',
        vehicle_arrival_time: 'Čas příjezdu vozidla',
        key_component_barcode: 'Čárový kód klíčové součásti',
        scan_time: 'Čas skenování',
        key_component_type_code: 'Typový kód klíčové součásti',
        key_component_type_desc: 'Čínský popis typů klíčových komponent',
        key_component_type_descen: 'Anglický popis typů klíčových komponent',
        part_number: 'Číslo dílu',
        supplier_name: 'Jméno dodavatele',
        traceability_number: 'Číslo sledovatelnosti',
        subcritical_component_type: 'Typ dílčí kritické součásti',
        batch_number: 'Číslo série',
        vehicle_base_info: 'Základní informace o vozidle',
        vehicle_crossing_data: 'Data o průjezdu vozidla',
        accurately_traceable_parts_list: 'Přesně sledovatelný seznam dílů',
        vehicle_configuration_information: 'Informace o konfiguraci vozidla',
        VIN: 'VIN',
        SAP_feature_ID: 'ID funkce SAP',
        SAP_feature_Codes: 'Kódy funkcí SAP',
        SAP_feature_Description: 'Popis funkce SAP',
        SAP_feature_value_Description: 'Popis hodnoty funkce SAP',
        SAP_feature_Description_EN: 'Popis funkce SAP (anglicky)',
        SAP_feature_value_Description_EN: 'Popis hodnoty funkce SAP (anglicky)',
        batteryNo: 'Číslo baterie',
        qmotorNo: 'Číslo předního motoru',
        hmotorNo: 'Číslo zadního motoru',
        feature_ID: 'ID funkce',
        feature_Description: 'Popis funkce (čínsky)',
        feature_Description_EN: 'Popis funkce (anglicky)',
        feature_Codes: 'Kódy funkce',
        feature_value_Description: 'Popis hodnoty funkce (čínsky)',
        feature_value_Description_EN: 'Popis hodnoty funkce (anglicky)',
        description_zh: 'Čínský popis',
        supplier: 'Dodavatel',
        barCoding: 'Čárové kódování',
        key_component_type_desc_En: 'Anglický popis typů klíčových komponent',
        partName: 'Název dílu (čínsky)',
        partName_En: 'Název dílu (anglicky)',
        workstation_code: 'Kód pracovní stanice',
        workstationDesc: 'Popis stanice (čínsky)',
        workstationDesc_En: 'Popis stanice (anglicky)',
        packageNo: 'Číslo bateriového balíku',
        packageType: 'Typ bateriového balíku',
        moduleNo: 'Číslo bateriového modulu',
        moduleType: 'Typ modulu',
        cellNo: 'Číslo jednotlivé baterie',
        cellModelId: 'Model jednotlivé baterie',
        uploadTime: 'Čas nahrání',
        vehicle_battery_data: 'Data baterie vozidla',
    },
    // 匈牙利语
    huHU: {
        factory: 'Gyár',
        vehicle_platform: 'Járműplatform',
        model_year: 'Modellév',
        order_no: 'Rendeléssz.',
        order_type: 'Rendeléstípus',
        vehicle_material_no: 'Jármű anyagsz.',
        engine_no: 'Motorsz.',
        certificate_no_14: '14. sz. tanúsítvány',
        certificate_no_15: '15. sz. tanúsítvány',
        certificate_date: 'Tanúsítvány dátuma',
        pn: 'Cikksz.',
        uptime: 'Végső összeszerelés megkezdésének időpontja',
        end_time: 'Jármű gyártásának befejezési ideje',
        bomversion: 'BOM-VERZIÓ',
        product_code: 'Termékkód',
        industrial_division: 'Ipari részleg (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Jármű anyagszám leírása',
        SAIC_order_number: 'SAIC International megrendelésszám',
        station_code: 'Állomáskód',
        station_desc: 'Állomásleírás',
        station_number: 'Állomásszám',
        station_name: 'Állomásnév',
        vehicle_arrival_time: 'Jármű érkezési ideje',
        key_component_barcode: 'Fődarab vonalkód',
        scan_time: 'Beolvasás ideje',
        key_component_type_code: 'Fődarab típuskódja',
        key_component_type_desc: 'Fődarabtípusok kínai leírása',
        key_component_type_descen: 'Fődarabtípusok angol leírása',
        part_number: 'Alkatrészszám',
        supplier_name: 'Beszállító neve',
        traceability_number: 'Nyomkövetési szám',
        subcritical_component_type: 'Alegység száma',
        batch_number: 'Kötegszám',
        vehicle_base_info: 'Jármű alapvető információi',
        vehicle_crossing_data: 'Járműátadási adatok',
        accurately_traceable_parts_list: 'Pontosan nyomon követhető alkatrészek listája',
        vehicle_configuration_information: 'Járműkonfigurációs adatok',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP-funkcióazonosító',
        SAP_feature_Codes: 'SAP-funkciókódok',
        SAP_feature_Description: 'SAP-funkcióleírás',
        SAP_feature_value_Description: 'SAP-funkcióértékleírás',
        SAP_feature_Description_EN: 'SAP-funkcióleírás (angol)',
        SAP_feature_value_Description_EN: 'SAP-funkcióértékleírás (angol)',
        batteryNo: 'Akkumulátor száma',
        qmotorNo: 'Első motor száma',
        hmotorNo: 'Hátsó motor száma',
        feature_ID: 'Funkcióazonosító',
        feature_Description: 'Funkcióleírás (kínai)',
        feature_Description_EN: 'Funkcióleírás (angol)',
        feature_Codes: 'Funkciókódok',
        feature_value_Description: 'Funkcióérték leírása (kínai)',
        feature_value_Description_EN: 'Funkcióérték leírása (angol)',
        description_zh: 'Kínai leírás',
        supplier: 'Beszállító',
        barCoding: 'Vonalkód',
        key_component_type_desc_En: 'Fődarabtípusok angol leírása',
        partName: 'Alkatrész kínai neve',
        partName_En: 'Alkatrész angol neve',
        workstation_code: 'Munkapont kód',
        workstationDesc: 'Munkapont leírása (kínai)',
        workstationDesc_En: 'Munkapont leírása (angol)',
        packageNo: 'Akkumulátor csomag kódja',
        packageType: 'Akkumulátor csomag típusa',
        moduleNo: 'Akkumulátor modul kódja',
        moduleType: 'Modul típusa',
        cellNo: 'Cellás akkumulátor kód',
        cellModelId: 'Cellás típusa',
        uploadTime: 'Jelentési idő',
        vehicle_battery_data: 'Jármű pontos nyomkövetési akkumulátor adatok',
    },
    // 俄罗斯语
    ruRU: {
        factory: 'Завод',
        vehicle_platform: 'Платформа автомобиля',
        model_year: 'Год модели',
        order_no: 'Номер заказа',
        order_type: 'Тип заказа',
        vehicle_material_no: 'Номер материала автомобиля',
        engine_no: 'Номер двигателя',
        certificate_no_14: 'Сертификат № 14',
        certificate_no_15: 'Сертификат № 15',
        certificate_date: 'Дата сертификата',
        pn: 'Pn',
        uptime: 'Время запуска окончательной сборки',
        end_time: 'Время завершения производства автомобиля',
        bomversion: 'BOMVERSION',
        product_code: 'Код продукта',
        industrial_division: 'Промышленное подразделение (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Описание номера материала автомобиля',
        SAIC_order_number: 'Номер международного заказа SAIC',
        station_code: 'Код станции',
        station_desc: 'Описание станции',
        station_number: 'Номер станции',
        station_name: 'Название станции',
        vehicle_arrival_time: 'Время прибытия автомобиля',
        key_component_barcode: 'Штрих-код ключевого компонента',
        scan_time: 'Время сканирования',
        key_component_type_code: 'Код типа ключевого компонента',
        key_component_type_desc: 'Описание типа ключевого компонента на китайском',
        key_component_type_descen: 'Описание типа ключевого компонента на английском',
        part_number: 'Номер детали',
        supplier_name: 'Имя поставщика',
        traceability_number: 'Номер отслеживания',
        subcritical_component_type: 'Подкритический компонент',
        batch_number: 'Номер партии',
        vehicle_base_info: 'Основная информация об автомобиле',
        vehicle_crossing_data: 'Данные о пересечении автомобиля',
        accurately_traceable_parts_list: 'Точно отслеживаемый список деталей',
        vehicle_configuration_information: 'Информация о конфигурации автомобиля',
        VIN: 'VIN',
        SAP_feature_ID: 'ID функции SAP',
        SAP_feature_Codes: 'Коды функций SAP',
        SAP_feature_Description: 'Описание функций SAP',
        SAP_feature_value_Description: 'Описание значений функций SAP',
        SAP_feature_Description_EN: 'Описание на английском',
        SAP_feature_value_Description_EN: 'Описание значений функций SAP на английском',
        batteryNo: 'Номер батареи',
        qmotorNo: 'Номер переднего мотора',
        hmotorNo: 'Номер заднего мотора',
        feature_ID: 'ID функции',
        feature_Description: 'Описание функции (китайский)',
        feature_Description_EN: 'Описание функции (английский)',
        feature_Codes: 'Коды функций',
        feature_value_Description: 'Описание значений функций (китайский)',
        feature_value_Description_EN: 'Описание значений функций (английский)',
        description_zh: 'Описание (китайский)',
        supplier: 'Поставщик',
        barCoding: 'Штрих-код',
        key_component_type_desc_En: 'Описание типа ключевого компонента (английский)',
        partName: 'Название детали (китайский)',
        partName_En: 'Название детали (английский)',
        workstation_code: 'Код рабочего места',
        workstationDesc: 'Описание рабочего места (китайский)',
        workstationDesc_En: 'Описание рабочего места (английский)',
        packageNo: 'Код упаковки батареи',
        packageType: 'Модель упаковки батареи',
        moduleNo: 'Код модуля батареи',
        moduleType: 'Модель модуля',
        cellNo: 'Код отдельной ячейки',
        cellModelId: 'Модель отдельной ячейки',
        uploadTime: 'Время загрузки',
        vehicle_battery_data: 'Данные о батарее автомобиля',
    },
    arSA: {
        factory: 'المصنع',
        vehicle_platform: 'منصة الطراز',
        model_year: 'سنة الطراز',
        order_no: 'رقم الطلب',
        order_type: 'نوع الطلب',
        vehicle_material_no: 'رقم مادة المركبة الكاملة',
        engine_no: 'رقم محرك التسلسلي',
        certificate_no_14: 'رقم شهادة المطابقة المكوّن من 14 رقمًا',
        certificate_no_15: 'رقم شهادة المطابقة المكوّن من 15 رقمًا',
        certificate_date: 'تاريخ طباعة شهادة المطابقة',
        pn: 'PIN',
        uptime: 'وقت دخول خط التجميع النهائي',
        end_time: 'وقت انتهاء إنتاج المركبة',
        bomversion: 'BOMVERSION',
        product_code: 'رمز الإنتاج',
        industrial_division: 'تصنيف الإنتاج (CKD، SKD، CBU)',
        vehicle_material_number_description: 'وصف رقم مادة المركبة الكاملة',
        SAIC_order_number: 'رقم طلب SAIC الدولي',
        station_code: 'رمز المصنع',
        station_desc: 'وصف المصنع',
        station_number: 'رقم محطة العمل',
        station_name: 'اسم محطة العمل',
        vehicle_arrival_time: 'وقت وصول المركبة',
        key_component_barcode: 'باركود المكون الرئيسي',
        scan_time: 'وقت المسح',
        key_component_type_code: 'رمز نوع المكون الرئيسي',
        key_component_type_desc: 'وصف نوع المكون الرئيسي (بالصينية)',
        key_component_type_descen: 'وصف نوع المكون الرئيسي (بالإنجليزية)',
        part_number: 'رقم القطعة',
        supplier_name: 'اسم المورّد',
        traceability_number: 'رقم التتبع',
        subcritical_component_type: 'نوع المكون الفرعي الرئيسي',
        batch_number: 'رقم الدفعة',
        vehicle_base_info: 'المعلومات الأساسية للمركبة',
        vehicle_crossing_data: 'بيانات نقاط عبور المركبة',
        accurately_traceable_parts_list: 'قائمة الأجزاء القابلة للتتبع بدقة',
        vehicle_configuration_information: 'معلومات تكوين المركبة',
        VIN: 'VIN',
        SAP_feature_ID: 'معرّف سمة SAP',
        SAP_feature_Codes: 'رموز سمة SAP',
        SAP_feature_Description: 'وصف سمة SAP',
        SAP_feature_value_Description: 'وصف قيمة سمة SAP',
        SAP_feature_Description_EN: 'وصف سمة SAP (بالإنجليزية)',
        SAP_feature_value_Description_EN: 'وصف قيمة سمة SAP (بالإنجليزية)',
        batteryNo: 'رقم البطارية',
        qmotorNo: 'رقم المحرك الأمامي',
        hmotorNo: 'رقم المحرك الخلفي',
        feature_ID: 'معرّف السمة',
        feature_Description: 'وصف السمة (بالصينية)',
        feature_Description_EN: 'وصف السمة (بالإنجليزية)',
        feature_Codes: 'رمز السمة',
        feature_value_Description: 'وصف قيمة السمة (بالصينية)',
        feature_value_Description_EN: 'وصف قيمة السمة (بالإنجليزية)',
        description_zh: 'الوصف بالصينية',
        supplier: 'المورّد',
        barCoding: 'ترميز الباركود',
        key_component_type_desc_En: 'وصف نوع المكون الرئيسي (بالإنجليزية)',
        partName: 'اسم القطعة بالصينية',
        partName_En: 'اسم القطعة بالإنجليزية',
        workstation_code: 'رمز محطة العمل',
        workstationDesc: 'وصف محطة العمل (بالصينية)',
        workstationDesc_En: 'وصف محطة العمل (بالإنجليزية)',
        packageNo: 'رمز حزمة البطارية',
        packageType: 'طراز حزمة البطارية',
        moduleNo: 'رمز وحدة البطارية',
        moduleType: 'طراز الوحدة',
        cellNo: 'رمز خلية البطارية',
        cellModelId: 'طراز الخلية',
        uploadTime: 'وقت الإرسال',
        vehicle_battery_data: 'بيانات بطارية المركبة القابلة للتتبع الدقيق',
    },
    // 保加利亚语
    bgBG: {
        factory: 'Завод',
        vehicle_platform: 'Платформа на модела',
        model_year: 'Година на модела',
        order_no: 'Номер на поръчка',
        order_type: 'Тип на поръчката',
        vehicle_material_no: 'Номер на материал за цялото превозно средство',
        engine_no: 'Сериен номер на двигателя',
        certificate_no_14: '14-цифрен номер на сертификат за съответствие',
        certificate_no_15: '15-цифрен номер на сертификат за съответствие',
        certificate_date: 'Дата на отпечатване на сертификата',
        pn: 'PIN',
        uptime: 'Време на влизане в линията за крайна сборка',
        end_time: 'Време на приключване на производството на превозното средство',
        bomversion: 'BOMVERSION',
        product_code: 'Производствен код',
        industrial_division: 'Класификация на производството (CKD, SKD, CBU)',
        vehicle_material_number_description:
            'Описание на номера на материала за цялото превозно средство',
        SAIC_order_number: 'Номер на международна поръчка на SAIC',
        station_code: 'Код на завода',
        station_desc: 'Описание на завода',
        station_number: 'Номер на работното място',
        station_name: 'Име на работното място',
        vehicle_arrival_time: 'Време на пристигане на превозното средство',
        key_component_barcode: 'Баркод на ключов компонент',
        scan_time: 'Време на сканиране',
        key_component_type_code: 'Код на тип ключов компонент',
        key_component_type_desc: 'Описание на типа ключов компонент (на китайски)',
        key_component_type_descen: 'Описание на типа ключов компонент (на английски)',
        part_number: 'Номер на част',
        supplier_name: 'Име на доставчик',
        traceability_number: 'Номер за проследяване',
        subcritical_component_type: 'Тип подключов компонент',
        batch_number: 'Номер на партида',
        vehicle_base_info: 'Основна информация за превозното средство',
        vehicle_crossing_data: 'Данни за преминаване на превозното средство през точки',
        accurately_traceable_parts_list: 'Списък с точно проследими части',
        vehicle_configuration_information: 'Информация за конфигурацията на превозното средство',
        VIN: 'VIN',
        SAP_feature_ID: 'ID на характеристика в SAP',
        SAP_feature_Codes: 'Кодове на характеристика в SAP',
        SAP_feature_Description: 'Описание на характеристика в SAP',
        SAP_feature_value_Description: 'Описание на стойност на характеристика в SAP',
        SAP_feature_Description_EN: 'Описание на характеристика в SAP (на английски)',
        SAP_feature_value_Description_EN:
            'Описание на стойност на характеристика в SAP (на английски)',
        batteryNo: 'Номер на батерията',
        qmotorNo: 'Номер на предния мотор',
        hmotorNo: 'Номер на задния мотор',
        feature_ID: 'ID на характеристика',
        feature_Description: 'Описание на характеристика (на китайски)',
        feature_Description_EN: 'Описание на характеристика (на английски)',
        feature_Codes: 'Код на характеристика',
        feature_value_Description: 'Описание на стойност на характеристика (на китайски)',
        feature_value_Description_EN: 'Описание на стойност на характеристика (на английски)',
        description_zh: 'Китайско описание',
        supplier: 'Доставчик',
        barCoding: 'Баркодиране',
        key_component_type_desc_En: 'Описание на типа ключов компонент (на английски)',
        partName: 'Име на частта на китайски',
        partName_En: 'Име на частта на английски',
        workstation_code: 'Код на работното място',
        workstationDesc: 'Описание на работното място (на китайски)',
        workstationDesc_En: 'Описание на работното място (на английски)',
        packageNo: 'Код на батерийния пакет',
        packageType: 'Модел на батерийния пакет',
        moduleNo: 'Код на батерийния модул',
        moduleType: 'Модел на модула',
        cellNo: 'Код на отделната батерия',
        cellModelId: 'Модел на клетката',
        uploadTime: 'Време на изпращане',
        vehicle_battery_data: 'Данни за точно проследимата батерия на превозното средство',
    },

    // 丹麦语
    daDK: {
        factory: 'Fabrik',
        vehicle_platform: 'Køretøjsplatform',
        model_year: 'Modelår',
        order_no: 'Ordrenummer',
        order_type: 'Ordretype',
        vehicle_material_no: 'Helkøretøjsmateriale-nummer',
        engine_no: 'Motornummer',
        certificate_no_14: '14-cifret certifikatnummer',
        certificate_no_15: '15-cifret certifikatnummer',
        certificate_date: 'Certifikatudskrivningsdato',
        pn: 'PIN',
        uptime: 'Tid for monteringslinjens start',
        end_time: 'Tid for afslutning af køretøjsproduktion',
        bomversion: 'BOMVERSION',
        product_code: 'Produktionskode',
        industrial_division: 'Produktionsopdeling (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Beskrivelse af helkøretøjsmateriale-nummer',
        SAIC_order_number: 'SAIC international ordrenummer',
        station_code: 'Fabrikkode',
        station_desc: 'Fabriksbeskrivelse',
        station_number: 'Arbejdsstationsnummer',
        station_name: 'Arbejdsstationsnavn',
        vehicle_arrival_time: 'Køretøjets ankomsttid',
        key_component_barcode: 'Stregkode for nøglekomponent',
        scan_time: 'Scannetidspunkt',
        key_component_type_code: 'Kode for nøglekomponenttype',
        key_component_type_desc: 'Beskrivelse af nøglekomponenttype (kinesisk)',
        key_component_type_descen: 'Beskrivelse af nøglekomponenttype (engelsk)',
        part_number: 'Reservedelsnummer',
        supplier_name: 'Leverandørnavn',
        traceability_number: 'Sporbarhedsnummer',
        subcritical_component_type: 'Undertypenøglekomponent',
        batch_number: 'Batchnummer',
        vehicle_base_info: 'Grundlæggende køretøjsoplysninger',
        vehicle_crossing_data: 'Køretøjspassagedata',
        accurately_traceable_parts_list: 'Liste over præcist sporbare dele',
        vehicle_configuration_information: 'Køretøjskonfigurationsoplysninger',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP-funktions-ID',
        SAP_feature_Codes: 'SAP-funktionskoder',
        SAP_feature_Description: 'SAP-funktionsbeskrivelse',
        SAP_feature_value_Description: 'SAP-funktionsværdibeskrivelse',
        SAP_feature_Description_EN: 'SAP-funktionsbeskrivelse (engelsk)',
        SAP_feature_value_Description_EN: 'SAP-funktionsværdibeskrivelse (engelsk)',
        batteryNo: 'Batterinummer',
        qmotorNo: 'Forreste motor nummer',
        hmotorNo: 'Bageste motor nummer',
        feature_ID: 'Funktions-ID',
        feature_Description: 'Funktionsbeskrivelse (kinesisk)',
        feature_Description_EN: 'Funktionsbeskrivelse (engelsk)',
        feature_Codes: 'Funktionskode',
        feature_value_Description: 'Funktionsværdibeskrivelse (kinesisk)',
        feature_value_Description_EN: 'Funktionsværdibeskrivelse (engelsk)',
        description_zh: 'Kinesisk beskrivelse',
        supplier: 'Leverandør',
        barCoding: 'Stregkodning',
        key_component_type_desc_En: 'Beskrivelse af nøglekomponenttype (engelsk)',
        partName: 'Reservedelsnavn (kinesisk)',
        partName_En: 'Reservedelsnavn (engelsk)',
        workstation_code: 'Arbejdsstationskode',
        workstationDesc: 'Arbejdsstationsbeskrivelse (kinesisk)',
        workstationDesc_En: 'Arbejdsstationsbeskrivelse (engelsk)',
        packageNo: 'Batteripakkenummer',
        packageType: 'Batteripakketype',
        moduleNo: 'Batterimodulnummer',
        moduleType: 'Modultype',
        cellNo: 'Cellebatterinummer',
        cellModelId: 'Cellemodel',
        uploadTime: 'Upload-tidspunkt',
        vehicle_battery_data: 'Præcist sporbare batteridata for køretøj',
    },
    // 芬兰语
    fiFI: {
        factory: 'Tehdas',
        vehicle_platform: 'Ajoneuvomalli alusta',
        model_year: 'Mallivuosi',
        order_no: 'Tilausnumero',
        order_type: 'Tilaustyyppi',
        vehicle_material_no: 'Koko ajoneuvon materiaalinumero',
        engine_no: 'Moottorin sarjanumero',
        certificate_no_14: '14-numeroinen hyväksyntätodistusnumero',
        certificate_no_15: '15-numeroinen hyväksyntätodistusnumero',
        certificate_date: 'Hyväksyntätodistuksen tulostuspäivämäärä',
        pn: 'PIN',
        uptime: 'Viimeisen kokoonpanolinjan käynnistysaika',
        end_time: 'Ajoneuvon valmistumisaika',
        bomversion: 'BOMVERSION',
        product_code: 'Tuotantokoodi',
        industrial_division: 'Tuotantoluokitus (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Koko ajoneuvon materiaalinumeron kuvaus',
        SAIC_order_number: 'SAIC:n kansainvälinen tilausnumero',
        station_code: 'Tehdaskoodi',
        station_desc: 'Tehdaskuvaus',
        station_number: 'Työpistenumero',
        station_name: 'Työpisteen nimi',
        vehicle_arrival_time: 'Ajoneuvon saapumisaika',
        key_component_barcode: 'Avainosan viivakoodi',
        scan_time: 'Skannaushetki',
        key_component_type_code: 'Avainosatyypin koodi',
        key_component_type_desc: 'Avainosatyypin kuvaus (kiinaksi)',
        key_component_type_descen: 'Avainosatyypin kuvaus (englanniksi)',
        part_number: 'Osanumero',
        supplier_name: 'Toimittajan nimi',
        traceability_number: 'Jäljitettävyysnumero',
        subcritical_component_type: 'Ala-avainosatyyppi',
        batch_number: 'Eränumero',
        vehicle_base_info: 'Ajoneuvon perustiedot',
        vehicle_crossing_data: 'Ajoneuvon ohitusdata',
        accurately_traceable_parts_list: 'Tarkasti jäljitettävien osien luettelo',
        vehicle_configuration_information: 'Ajoneuvon määritystiedot',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP-ominaisuuden tunniste',
        SAP_feature_Codes: 'SAP-ominaisuuskoodit',
        SAP_feature_Description: 'SAP-ominaisuuden kuvaus',
        SAP_feature_value_Description: 'SAP-ominaisuusarvon kuvaus',
        SAP_feature_Description_EN: 'SAP-ominaisuuden kuvaus (englanniksi)',
        SAP_feature_value_Description_EN: 'SAP-ominaisuusarvon kuvaus (englanniksi)',
        batteryNo: 'Akun numero',
        qmotorNo: 'Etummoottorin numero',
        hmotorNo: 'Takamoottorin numero',
        feature_ID: 'Ominaisuustunniste',
        feature_Description: 'Ominaisuuden kuvaus (kiinaksi)',
        feature_Description_EN: 'Ominaisuuden kuvaus (englanniksi)',
        feature_Codes: 'Ominaisuuskoodi',
        feature_value_Description: 'Ominaisuusarvon kuvaus (kiinaksi)',
        feature_value_Description_EN: 'Ominaisuusarvon kuvaus (englanniksi)',
        description_zh: 'Kiinalainen kuvaus',
        supplier: 'Toimittaja',
        barCoding: 'Viivakoodaus',
        key_component_type_desc_En: 'Avainosatyypin kuvaus (englanniksi)',
        partName: 'Osan nimi (kiinaksi)',
        partName_En: 'Osan nimi (englanniksi)',
        workstation_code: 'Työpistekoodi',
        workstationDesc: 'Työpisteen kuvaus (kiinaksi)',
        workstationDesc_En: 'Työpisteen kuvaus (englanniksi)',
        packageNo: 'Akku-paketin koodi',
        packageType: 'Akku-paketin malli',
        moduleNo: 'Akku-moduulin koodi',
        moduleType: 'Moduulin malli',
        cellNo: 'Yksittäisen akun koodi',
        cellModelId: 'Solun malli',
        uploadTime: 'Lähetyshetki',
        vehicle_battery_data: 'Ajoneuvon tarkasti jäljitettävä akkutieto',
    },
    // 繁体中文（台湾）
    zhTW: {
        factory: '工廠',
        vehicle_platform: '車型平台',
        model_year: '車型年',
        order_no: '訂單號',
        order_type: '訂單類型',
        vehicle_material_no: '整車物料號',
        engine_no: '發動機序列號',
        certificate_no_14: '14位合格證號',
        certificate_no_15: '15位合格證號',
        certificate_date: '合格證列印日期',
        pn: 'PIN',
        uptime: '總裝上線時間',
        end_time: '車輛生產結束時間',
        bomversion: 'BOMVERSION',
        product_code: '生產代碼',
        industrial_division: '生產區分(CKD、SKD、CBU)',
        vehicle_material_number_description: '整車物料號描述',
        SAIC_order_number: '上汽國際訂單號',
        station_code: '工廠代碼',
        station_desc: '工廠描述',
        station_number: '工位編號',
        station_name: '工位名稱',
        vehicle_arrival_time: '車輛到達時間',
        key_component_barcode: '關鍵件條碼',
        scan_time: '掃描時間',
        key_component_type_code: '關鍵件類型編碼',
        key_component_type_desc: '關鍵件類型描述(中文)',
        key_component_type_descen: '關鍵件類型描述(英文)',
        part_number: '零件號',
        supplier_name: '供應商名稱',
        traceability_number: '追溯號',
        subcritical_component_type: '子關鍵件類型',
        batch_number: '批次號',
        vehicle_base_info: '車輛基礎資訊',
        vehicle_crossing_data: '車輛過點資料',
        accurately_traceable_parts_list: '精確追溯零件清單',
        vehicle_configuration_information: '車輛配置資訊',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP 特徵 ID',
        SAP_feature_Codes: 'SAP 特徵碼',
        SAP_feature_Description: 'SAP 特徵描述',
        SAP_feature_value_Description: 'SAP 特徵值描述',
        SAP_feature_Description_EN: 'SAP 特徵描述(英文)',
        SAP_feature_value_Description_EN: 'SAP 特徵值描述(英文)',
        batteryNo: '電池編號',
        qmotorNo: '前電機編號',
        hmotorNo: '後電機編號',
        feature_ID: '特徵ID',
        feature_Description: '特徵描述(中文)',
        feature_Description_EN: '特徵描述(英文)',
        feature_Codes: '特徵碼',
        feature_value_Description: '特徵值描述(中文)',
        feature_value_Description_EN: '特徵值描述(英文)',
        description_zh: '中文描述',
        supplier: '供應商',
        barCoding: '條形編碼',
        key_component_type_desc_En: '關鍵件類型描述(英文)',
        partName: '零件中文名稱',
        partName_En: '零件英文名稱',
        workstation_code: '工位代碼',
        workstationDesc: '工位描述(中文)',
        workstationDesc_En: '工位描述(英文)',
        packageNo: '電池包編碼',
        packageType: '電池包型號',
        moduleNo: '電池模組編碼',
        moduleType: '模組型號',
        cellNo: '單體電池編碼',
        cellModelId: '單體型號',
        uploadTime: '報送時間',
        vehicle_battery_data: '車輛精追電池資料',
    },
    // 克罗地亚
    hrHR: {
        factory: 'Tvornica',
        vehicle_platform: 'Platforma vozila',
        model_year: 'Godina modela',
        order_no: 'Broj narudžbe',
        order_type: 'Vrsta narudžbe',
        vehicle_material_no: 'Broj materijala za cijelo vozilo',
        engine_no: 'Serijski broj motora',
        certificate_no_14: '14-znamenkasti broj certifikata',
        certificate_no_15: '15-znamenkasti broj certifikata',
        certificate_date: 'Datum ispisa certifikata',
        pn: 'PIN',
        uptime: 'Vrijeme ulaska u završnu montažu',
        end_time: 'Vrijeme završetka proizvodnje vozila',
        bomversion: 'BOMVERSION',
        product_code: 'Proizvodni kod',
        industrial_division: 'Podjela proizvodnje (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Opis broja materijala za cijelo vozilo',
        SAIC_order_number: 'Međunarodni broj narudžbe SAIC-a',
        station_code: 'Kôd tvornice',
        station_desc: 'Opis tvornice',
        station_number: 'Broj radnog mjesta',
        station_name: 'Naziv radnog mjesta',
        vehicle_arrival_time: 'Vrijeme dolaska vozila',
        key_component_barcode: 'Bar kod ključne komponente',
        scan_time: 'Vrijeme skeniranja',
        key_component_type_code: 'Šifra vrste ključne komponente',
        key_component_type_desc: 'Opis vrste ključne komponente (na kineskom)',
        key_component_type_descen: 'Opis vrste ključne komponente (na engleskom)',
        part_number: 'Broj dijela',
        supplier_name: 'Naziv dobavljača',
        traceability_number: 'Broj za praćenje',
        subcritical_component_type: 'Vrsta podključne komponente',
        batch_number: 'Broj serije',
        vehicle_base_info: 'Osnovne informacije o vozilu',
        vehicle_crossing_data: 'Podaci o prolasku vozila kroz točke',
        accurately_traceable_parts_list: 'Popis precizno praćenih dijelova',
        vehicle_configuration_information: 'Informacije o konfiguraciji vozila',
        VIN: 'VIN',
        SAP_feature_ID: 'ID SAP značajke',
        SAP_feature_Codes: 'Kodovi SAP značajke',
        SAP_feature_Description: 'Opis SAP značajke',
        SAP_feature_value_Description: 'Opis vrijednosti SAP značajke',
        SAP_feature_Description_EN: 'Opis SAP značajke (na engleskom)',
        SAP_feature_value_Description_EN: 'Opis vrijednosti SAP značajke (na engleskom)',
        batteryNo: 'Broj baterije',
        qmotorNo: 'Broj prednjeg motora',
        hmotorNo: 'Broj stražnjeg motora',
        feature_ID: 'ID značajke',
        feature_Description: 'Opis značajke (na kineskom)',
        feature_Description_EN: 'Opis značajke (na engleskom)',
        feature_Codes: 'Kod značajke',
        feature_value_Description: 'Opis vrijednosti značajke (na kineskom)',
        feature_value_Description_EN: 'Opis vrijednosti značajke (na engleskom)',
        description_zh: 'Opis na kineskom',
        supplier: 'Dobavljač',
        barCoding: 'Bar kodiranje',
        key_component_type_desc_En: 'Opis vrste ključne komponente (na engleskom)',
        partName: 'Naziv dijela (na kineskom)',
        partName_En: 'Naziv dijela (na engleskom)',
        workstation_code: 'Kôd radnog mjesta',
        workstationDesc: 'Opis radnog mjesta (na kineskom)',
        workstationDesc_En: 'Opis radnog mjesta (na engleskom)',
        packageNo: 'Kôd baterijskog paketa',
        packageType: 'Model baterijskog paketa',
        moduleNo: 'Kôd baterijskog modula',
        moduleType: 'Model modula',
        cellNo: 'Kôd pojedinačne ćelije',
        cellModelId: 'Model ćelije',
        uploadTime: 'Vrijeme prijenosa',
        vehicle_battery_data: 'Podaci o precizno praćenoj bateriji vozila',
    },
    // 拉脱维亚
    lvLV: {
        factory: 'Rūpnīca',
        vehicle_platform: 'Transportlīdzekļa platforma',
        model_year: 'Modeļa gads',
        order_no: 'Pasūtījuma numurs',
        order_type: 'Pasūtījuma veids',
        vehicle_material_no: 'Vesela transportlīdzekļa materiāla numurs',
        engine_no: 'Dzinēja sērijas numurs',
        certificate_no_14: '14 ciparu atbilstības sertifikāta numurs',
        certificate_no_15: '15 ciparu atbilstības sertifikāta numurs',
        certificate_date: 'Sertifikāta drukāšanas datums',
        pn: 'PIN',
        uptime: 'Montāžas līnijas sākuma laiks',
        end_time: 'Transportlīdzekļa ražošanas beigu laiks',
        bomversion: 'BOMVERSION',
        product_code: 'Ražošanas kods',
        industrial_division: 'Ražošanas klasifikācija (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Vesela transportlīdzekļa materiāla numura apraksts',
        SAIC_order_number: 'SAIC starptautiskā pasūtījuma numurs',
        station_code: 'Rūpnīcas kods',
        station_desc: 'Rūpnīcas apraksts',
        station_number: 'Darba stacijas numurs',
        station_name: 'Darba stacijas nosaukums',
        vehicle_arrival_time: 'Transportlīdzekļa ierašanās laiks',
        key_component_barcode: 'Galvenās komponentes svītrkods',
        scan_time: 'Skenēšanas laiks',
        key_component_type_code: 'Galvenās komponentes tipa kods',
        key_component_type_desc: 'Galvenās komponentes tipa apraksts (Ķīniešu valodā)',
        key_component_type_descen: 'Galvenās komponentes tipa apraksts (Angļu valodā)',
        part_number: 'Detaļas numurs',
        supplier_name: 'Piegādātāja nosaukums',
        traceability_number: 'Izsekojamības numurs',
        subcritical_component_type: 'Apakšgalvenās komponentes tips',
        batch_number: 'Partijas numurs',
        vehicle_base_info: 'Transportlīdzekļa pamatinformācija',
        vehicle_crossing_data: 'Transportlīdzekļa pārejas dati',
        accurately_traceable_parts_list: 'Precīzi izsekojamu detaļu saraksts',
        vehicle_configuration_information: 'Transportlīdzekļa konfigurācijas informācija',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP funkcijas ID',
        SAP_feature_Codes: 'SAP funkcijas kodi',
        SAP_feature_Description: 'SAP funkcijas apraksts',
        SAP_feature_value_Description: 'SAP funkcijas vērtības apraksts',
        SAP_feature_Description_EN: 'SAP funkcijas apraksts (angļu valodā)',
        SAP_feature_value_Description_EN: 'SAP funkcijas vērtības apraksts (angļu valodā)',
        batteryNo: 'Akumulatora numurs',
        qmotorNo: 'Priekšējā motora numurs',
        hmotorNo: 'Aizmugurējā motora numurs',
        feature_ID: 'Funkcijas ID',
        feature_Description: 'Funkcijas apraksts (ķīniešu valodā)',
        feature_Description_EN: 'Funkcijas apraksts (angļu valodā)',
        feature_Codes: 'Funkcijas kods',
        feature_value_Description: 'Funkcijas vērtības apraksts (ķīniešu valodā)',
        feature_value_Description_EN: 'Funkcijas vērtības apraksts (angļu valodā)',
        description_zh: 'Apraksts ķīniešu valodā',
        supplier: 'Piegādātājs',
        barCoding: 'Svītrkodēšana',
        key_component_type_desc_En: 'Galvenās komponentes tipa apraksts (angļu valodā)',
        partName: 'Detaļas nosaukums (ķīniešu valodā)',
        partName_En: 'Detaļas nosaukums (angļu valodā)',
        workstation_code: 'Darba stacijas kods',
        workstationDesc: 'Darba stacijas apraksts (ķīniešu valodā)',
        workstationDesc_En: 'Darba stacijas apraksts (angļu valodā)',
        packageNo: 'Akumulatora pakas kods',
        packageType: 'Akumulatora pakas modelis',
        moduleNo: 'Akumulatora moduļa kods',
        moduleType: 'Moduļa modelis',
        cellNo: 'Atsevišķas baterijas kods',
        cellModelId: 'Šūnas modelis',
        uploadTime: 'Augšupielādes laiks',
        vehicle_battery_data: 'Transportlīdzekļa precīzi izsekojamie akumulatora dati',
    },
    // 立陶宛
    ltLT: {
        factory: 'Gamykla',
        vehicle_platform: 'Transporto priemonės platforma',
        model_year: 'Modelio metai',
        order_no: 'Užsakymo numeris',
        order_type: 'Užsakymo tipas',
        vehicle_material_no: 'Visos transporto priemonės medžiagos numeris',
        engine_no: 'Variklio serijos numeris',
        certificate_no_14: '14 skaitmenų atitikties sertifikato numeris',
        certificate_no_15: '15 skaitmenų atitikties sertifikato numeris',
        certificate_date: 'Sertifikato spausdinimo data',
        pn: 'PIN',
        uptime: 'Galutinės surinkimo linijos pradžios laikas',
        end_time: 'Transporto priemonės gamybos pabaigos laikas',
        bomversion: 'BOMVERSION',
        product_code: 'Gamybos kodas',
        industrial_division: 'Gamybos klasifikacija (CKD, SKD, CBU)',
        vehicle_material_number_description:
            'Visos transporto priemonės medžiagos numerio aprašymas',
        SAIC_order_number: 'SAIC tarptautinio užsakymo numeris',
        station_code: 'Gamyklos kodas',
        station_desc: 'Gamyklos aprašymas',
        station_number: 'Darbo vietos numeris',
        station_name: 'Darbo vietos pavadinimas',
        vehicle_arrival_time: 'Transporto priemonės atvykimo laikas',
        key_component_barcode: 'Pagrindinės dalies brūkšninis kodas',
        scan_time: 'Skanavimo laikas',
        key_component_type_code: 'Pagrindinės dalies tipo kodas',
        key_component_type_desc: 'Pagrindinės dalies tipo aprašymas (kinų kalba)',
        key_component_type_descen: 'Pagrindinės dalies tipo aprašymas (anglų kalba)',
        part_number: 'Detalės numeris',
        supplier_name: 'Tiekėjo pavadinimas',
        traceability_number: 'Sekamumo numeris',
        subcritical_component_type: 'Subpagrindinės dalies tipas',
        batch_number: 'Partijos numeris',
        vehicle_base_info: 'Transporto priemonės pagrindinė informacija',
        vehicle_crossing_data: 'Transporto priemonės pravažiavimo duomenys',
        accurately_traceable_parts_list: 'Tiksliai sekamų dalių sąrašas',
        vehicle_configuration_information: 'Transporto priemonės konfigūracijos informacija',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP ypatybės ID',
        SAP_feature_Codes: 'SAP ypatybių kodai',
        SAP_feature_Description: 'SAP ypatybės aprašymas',
        SAP_feature_value_Description: 'SAP ypatybės reikšmės aprašymas',
        SAP_feature_Description_EN: 'SAP ypatybės aprašymas (anglų kalba)',
        SAP_feature_value_Description_EN: 'SAP ypatybės reikšmės aprašymas (anglų kalba)',
        batteryNo: 'Baterijos numeris',
        qmotorNo: 'Priekinio variklio numeris',
        hmotorNo: 'Galinio variklio numeris',
        feature_ID: 'Ypatybės ID',
        feature_Description: 'Ypatybės aprašymas (kinų kalba)',
        feature_Description_EN: 'Ypatybės aprašymas (anglų kalba)',
        feature_Codes: 'Ypatybės kodas',
        feature_value_Description: 'Ypatybės reikšmės aprašymas (kinų kalba)',
        feature_value_Description_EN: 'Ypatybės reikšmės aprašymas (anglų kalba)',
        description_zh: 'Aprašymas kinų kalba',
        supplier: 'Tiekėjas',
        barCoding: 'Brūkšninis kodavimas',
        key_component_type_desc_En: 'Pagrindinės dalies tipo aprašymas (anglų kalba)',
        partName: 'Detalės pavadinimas (kinų kalba)',
        partName_En: 'Detalės pavadinimas (anglų kalba)',
        workstation_code: 'Darbo vietos kodas',
        workstationDesc: 'Darbo vietos aprašymas (kinų kalba)',
        workstationDesc_En: 'Darbo vietos aprašymas (anglų kalba)',
        packageNo: 'Akumuliatorių pakuotės kodas',
        packageType: 'Akumuliatorių pakuotės modelis',
        moduleNo: 'Akumuliatoriaus modulio kodas',
        moduleType: 'Modulio modelis',
        cellNo: 'Atskiro elemento kodas',
        cellModelId: 'Elemento modelis',
        uploadTime: 'Įkėlimo laikas',
        vehicle_battery_data: 'Transporto priemonės tiksliai sekami akumuliatoriaus duomenys',
    },
    // 罗马尼亚
    roRO: {
        factory: 'Fabrică',
        vehicle_platform: 'Platformă vehicul',
        model_year: 'An model',
        order_no: 'Număr comandă',
        order_type: 'Tip comandă',
        vehicle_material_no: 'Număr material vehicul complet',
        engine_no: 'Număr de serie motor',
        certificate_no_14: 'Număr certificat de conformitate cu 14 cifre',
        certificate_no_15: 'Număr certificat de conformitate cu 15 cifre',
        certificate_date: 'Data tipăririi certificatului',
        pn: 'PIN',
        uptime: 'Timp intrare în linia de asamblare finală',
        end_time: 'Timp finalizare producție vehicul',
        bomversion: 'BOMVERSION',
        product_code: 'Cod producție',
        industrial_division: 'Clasificare producție (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Descriere număr material vehicul complet',
        SAIC_order_number: 'Număr comandă internațională SAIC',
        station_code: 'Cod fabrică',
        station_desc: 'Descriere fabrică',
        station_number: 'Număr post de lucru',
        station_name: 'Denumire post de lucru',
        vehicle_arrival_time: 'Timp sosire vehicul',
        key_component_barcode: 'Cod de bare componentă cheie',
        scan_time: 'Timp scanare',
        key_component_type_code: 'Cod tip componentă cheie',
        key_component_type_desc: 'Descriere tip componentă cheie (chineză)',
        key_component_type_descen: 'Descriere tip componentă cheie (engleză)',
        part_number: 'Număr piesă',
        supplier_name: 'Nume furnizor',
        traceability_number: 'Număr trasabilitate',
        subcritical_component_type: 'Tip subcomponentă cheie',
        batch_number: 'Număr lot',
        vehicle_base_info: 'Informații de bază vehicul',
        vehicle_crossing_data: 'Date trecere puncte vehicul',
        accurately_traceable_parts_list: 'Listă piese trasabile precis',
        vehicle_configuration_information: 'Informații configurație vehicul',
        VIN: 'VIN',
        SAP_feature_ID: 'ID caracteristică SAP',
        SAP_feature_Codes: 'Coduri caracteristică SAP',
        SAP_feature_Description: 'Descriere caracteristică SAP',
        SAP_feature_value_Description: 'Descriere valoare caracteristică SAP',
        SAP_feature_Description_EN: 'Descriere caracteristică SAP (engleză)',
        SAP_feature_value_Description_EN: 'Descriere valoare caracteristică SAP (engleză)',
        batteryNo: 'Număr baterie',
        qmotorNo: 'Număr motor față',
        hmotorNo: 'Număr motor spate',
        feature_ID: 'ID caracteristică',
        feature_Description: 'Descriere caracteristică (chineză)',
        feature_Description_EN: 'Descriere caracteristică (engleză)',
        feature_Codes: 'Cod caracteristică',
        feature_value_Description: 'Descriere valoare caracteristică (chineză)',
        feature_value_Description_EN: 'Descriere valoare caracteristică (engleză)',
        description_zh: 'Descriere în chineză',
        supplier: 'Furnizor',
        barCoding: 'Codificare cod de bare',
        key_component_type_desc_En: 'Descriere tip componentă cheie (engleză)',
        partName: 'Denumire piesă (chineză)',
        partName_En: 'Denumire piesă (engleză)',
        workstation_code: 'Cod post de lucru',
        workstationDesc: 'Descriere post de lucru (chineză)',
        workstationDesc_En: 'Descriere post de lucru (engleză)',
        packageNo: 'Cod pachet baterie',
        packageType: 'Model pachet baterie',
        moduleNo: 'Cod modul baterie',
        moduleType: 'Model modul',
        cellNo: 'Cod celulă baterie',
        cellModelId: 'Model celulă',
        uploadTime: 'Timp încărcare',
        vehicle_battery_data: 'Date baterie vehicul trasabilă precis',
    },
    // 挪威博克马尔
    nbNO: {
        factory: 'Fabrikk',
        vehicle_platform: 'Kjøretøyplattform',
        model_year: 'Modellår',
        order_no: 'Ordrenummer',
        order_type: 'Ordretype',
        vehicle_material_no: 'Helkjøretøymateriale-nummer',
        engine_no: 'Motornummer',
        certificate_no_14: '14-sifret sertifikatnummer',
        certificate_no_15: '15-sifret sertifikatnummer',
        certificate_date: 'Sertifikatutskriftsdato',
        pn: 'PIN',
        uptime: 'Tid for monteringslinjens oppstart',
        end_time: 'Tid for avslutning av kjøretøyproduksjon',
        bomversion: 'BOMVERSION',
        product_code: 'Produksjonskode',
        industrial_division: 'Produksjonsinndeling (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Beskrivelse av helkjøretøymateriale-nummer',
        SAIC_order_number: 'SAIC internasjonalt ordrenummer',
        station_code: 'Fabrikkode',
        station_desc: 'Fabrikkbeskrivelse',
        station_number: 'Arbeidsstasjonsnummer',
        station_name: 'Arbeidsstasjonsnavn',
        vehicle_arrival_time: 'Kjøretøyets ankomsttid',
        key_component_barcode: 'Strekkode for nøkkelkomponent',
        scan_time: 'Skannetidspunkt',
        key_component_type_code: 'Kode for nøkkelkomponenttype',
        key_component_type_desc: 'Beskrivelse av nøkkelkomponenttype (kinesisk)',
        key_component_type_descen: 'Beskrivelse av nøkkelkomponenttype (engelsk)',
        part_number: 'Reservedelsnummer',
        supplier_name: 'Leverandørnavn',
        traceability_number: 'Sporbarhetsnummer',
        subcritical_component_type: 'Undertypenøkkelkomponent',
        batch_number: 'Batchnummer',
        vehicle_base_info: 'Grunnleggende kjøretøyinformasjon',
        vehicle_crossing_data: 'Kjøretøypassasjedata',
        accurately_traceable_parts_list: 'Liste over nøyaktig sporbare deler',
        vehicle_configuration_information: 'Kjøretøykonfigurasjonsinformasjon',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP-funksjons-ID',
        SAP_feature_Codes: 'SAP-funksjonskoder',
        SAP_feature_Description: 'SAP-funksjonsbeskrivelse',
        SAP_feature_value_Description: 'SAP-funksjonsverdibeskrivelse',
        SAP_feature_Description_EN: 'SAP-funksjonsbeskrivelse (engelsk)',
        SAP_feature_value_Description_EN: 'SAP-funksjonsverdibeskrivelse (engelsk)',
        batteryNo: 'Batterinummer',
        qmotorNo: 'Forreste motornummer',
        hmotorNo: 'Bakre motornummer',
        feature_ID: 'Funksjons-ID',
        feature_Description: 'Funksjonsbeskrivelse (kinesisk)',
        feature_Description_EN: 'Funksjonsbeskrivelse (engelsk)',
        feature_Codes: 'Funksjonskode',
        feature_value_Description: 'Funksjonsverdibeskrivelse (kinesisk)',
        feature_value_Description_EN: 'Funksjonsverdibeskrivelse (engelsk)',
        description_zh: 'Kinesisk beskrivelse',
        supplier: 'Leverandør',
        barCoding: 'Strekkoding',
        key_component_type_desc_En: 'Beskrivelse av nøkkelkomponenttype (engelsk)',
        partName: 'Reservedelsnavn (kinesisk)',
        partName_En: 'Reservedelsnavn (engelsk)',
        workstation_code: 'Arbeidsstasjonskode',
        workstationDesc: 'Arbeidsstasjonsbeskrivelse (kinesisk)',
        workstationDesc_En: 'Arbeidsstasjonsbeskrivelse (engelsk)',
        packageNo: 'Batteripakkenummer',
        packageType: 'Batteripakketype',
        moduleNo: 'Batterimodulnummer',
        moduleType: 'Modultype',
        cellNo: 'Enkeltbatterinummer',
        cellModelId: 'Cellemodell',
        uploadTime: 'Opplastingstidspunkt',
        vehicle_battery_data: 'Nøyaktig sporbare batteridata for kjøretøy',
    },
    // 葡萄牙语巴西
    ptBX: {
        factory: 'Fábrica',
        vehicle_platform: 'Plataforma do modelo',
        model_year: 'Ano do modelo',
        order_no: 'Número do pedido',
        order_type: 'Tipo de pedido',
        vehicle_material_no: 'Número do material do veículo completo',
        engine_no: 'Número de série do motor',
        certificate_no_14: 'Número do certificado de conformidade com 14 dígitos',
        certificate_no_15: 'Número do certificado de conformidade com 15 dígitos',
        certificate_date: 'Data de impressão do certificado',
        pn: 'PIN',
        uptime: 'Horário de entrada na linha de montagem final',
        end_time: 'Horário de conclusão da produção do veículo',
        bomversion: 'BOMVERSION',
        product_code: 'Código de produção',
        industrial_division: 'Classificação de produção (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Descrição do número do material do veículo completo',
        SAIC_order_number: 'Número do pedido internacional SAIC',
        station_code: 'Código da fábrica',
        station_desc: 'Descrição da fábrica',
        station_number: 'Número da estação de trabalho',
        station_name: 'Nome da estação de trabalho',
        vehicle_arrival_time: 'Horário de chegada do veículo',
        key_component_barcode: 'Código de barras do componente crítico',
        scan_time: 'Horário da leitura',
        key_component_type_code: 'Código do tipo de componente crítico',
        key_component_type_desc: 'Descrição do tipo de componente crítico (chinês)',
        key_component_type_descen: 'Descrição do tipo de componente crítico (inglês)',
        part_number: 'Número da peça',
        supplier_name: 'Nome do fornecedor',
        traceability_number: 'Número de rastreabilidade',
        subcritical_component_type: 'Tipo de subcomponente crítico',
        batch_number: 'Número do lote',
        vehicle_base_info: 'Informações básicas do veículo',
        vehicle_crossing_data: 'Dados de passagem do veículo por pontos',
        accurately_traceable_parts_list: 'Lista de peças rastreáveis com precisão',
        vehicle_configuration_information: 'Informações de configuração do veículo',
        VIN: 'VIN',
        SAP_feature_ID: 'ID do recurso SAP',
        SAP_feature_Codes: 'Códigos do recurso SAP',
        SAP_feature_Description: 'Descrição do recurso SAP',
        SAP_feature_value_Description: 'Descrição do valor do recurso SAP',
        SAP_feature_Description_EN: 'Descrição do recurso SAP (inglês)',
        SAP_feature_value_Description_EN: 'Descrição do valor do recurso SAP (inglês)',
        batteryNo: 'Número da bateria',
        qmotorNo: 'Número do motor dianteiro',
        hmotorNo: 'Número do motor traseiro',
        feature_ID: 'ID do recurso',
        feature_Description: 'Descrição do recurso (chinês)',
        feature_Description_EN: 'Descrição do recurso (inglês)',
        feature_Codes: 'Código do recurso',
        feature_value_Description: 'Descrição do valor do recurso (chinês)',
        feature_value_Description_EN: 'Descrição do valor do recurso (inglês)',
        description_zh: 'Descrição em chinês',
        supplier: 'Fornecedor',
        barCoding: 'Codificação de código de barras',
        key_component_type_desc_En: 'Descrição do tipo de componente crítico (inglês)',
        partName: 'Nome da peça (chinês)',
        partName_En: 'Nome da peça (inglês)',
        workstation_code: 'Código da estação de trabalho',
        workstationDesc: 'Descrição da estação de trabalho (chinês)',
        workstationDesc_En: 'Descrição da estação de trabalho (inglês)',
        packageNo: 'Código do pacote de bateria',
        packageType: 'Modelo do pacote de bateria',
        moduleNo: 'Código do módulo de bateria',
        moduleType: 'Modelo do módulo',
        cellNo: 'Código da célula da bateria',
        cellModelId: 'Modelo da célula',
        uploadTime: 'Horário de envio',
        vehicle_battery_data: 'Dados precisos de rastreamento da bateria do veículo',
    },
    // 瑞典语
    svSE: {
        factory: 'Fabrik',
        vehicle_platform: 'Fordonsplattform',
        model_year: 'Modellår',
        order_no: 'Ordernummer',
        order_type: 'Ordertyp',
        vehicle_material_no: 'Helbilsmaterialnummer',
        engine_no: 'Motorns serienummer',
        certificate_no_14: '14-siffrigt certifikatnummer',
        certificate_no_15: '15-siffrigt certifikatnummer',
        certificate_date: 'Certifikatutskriftsdatum',
        pn: 'PIN',
        uptime: 'Tid för monteringslinjens igångsättning',
        end_time: 'Tid för avslutad fordonstillverkning',
        bomversion: 'BOMVERSION',
        product_code: 'Produktionskod',
        industrial_division: 'Produktionsklassificering (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Beskrivning av helbilsmaterialnummer',
        SAIC_order_number: 'SAIC internationellt ordernummer',
        station_code: 'Fabrikkod',
        station_desc: 'Fabriksbeskrivning',
        station_number: 'Arbetsstationsnummer',
        station_name: 'Arbetsstationsnamn',
        vehicle_arrival_time: 'Fordons ankomsttid',
        key_component_barcode: 'Streckkod för nyckelkomponent',
        scan_time: 'Skannings tidpunkt',
        key_component_type_code: 'Kod för nyckelkomponenttyp',
        key_component_type_desc: 'Beskrivning av nyckelkomponenttyp (kinesiska)',
        key_component_type_descen: 'Beskrivning av nyckelkomponenttyp (engelska)',
        part_number: 'Reservdelsnummer',
        supplier_name: 'Leverantörsnamn',
        traceability_number: 'Spårbarhetsnummer',
        subcritical_component_type: 'Undertyperad nyckelkomponent',
        batch_number: 'Batchnummer',
        vehicle_base_info: 'Grundläggande fordonsinformation',
        vehicle_crossing_data: 'Fordonspassagedata',
        accurately_traceable_parts_list: 'Lista över exakt spårbara delar',
        vehicle_configuration_information: 'Fordonskonfigurationsinformation',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP-funktions-ID',
        SAP_feature_Codes: 'SAP-funktionskoder',
        SAP_feature_Description: 'SAP-funktionsbeskrivning',
        SAP_feature_value_Description: 'SAP-funktionsvärdesbeskrivning',
        SAP_feature_Description_EN: 'SAP-funktionsbeskrivning (engelska)',
        SAP_feature_value_Description_EN: 'SAP-funktionsvärdesbeskrivning (engelska)',
        batteryNo: 'Batterinummer',
        qmotorNo: 'Frammotor nummer',
        hmotorNo: 'Bakmotor nummer',
        feature_ID: 'Funktions-ID',
        feature_Description: 'Funktionsbeskrivning (kinesiska)',
        feature_Description_EN: 'Funktionsbeskrivning (engelska)',
        feature_Codes: 'Funktionskod',
        feature_value_Description: 'Funktionsvärdesbeskrivning (kinesiska)',
        feature_value_Description_EN: 'Funktionsvärdesbeskrivning (engelska)',
        description_zh: 'Kinesisk beskrivning',
        supplier: 'Leverantör',
        barCoding: 'Streckkodning',
        key_component_type_desc_En: 'Beskrivning av nyckelkomponenttyp (engelska)',
        partName: 'Reservdelsnamn (kinesiska)',
        partName_En: 'Reservdelsnamn (engelska)',
        workstation_code: 'Arbetsstationskod',
        workstationDesc: 'Arbetsstationsbeskrivning (kinesiska)',
        workstationDesc_En: 'Arbetsstationsbeskrivning (engelska)',
        packageNo: 'Batteripaketkod',
        packageType: 'Batteripaketmodell',
        moduleNo: 'Batterimodulkod',
        moduleType: 'Modelltyp',
        cellNo: 'Enskild battericellkod',
        cellModelId: 'Cellmodell',
        uploadTime: 'Uppladdningstid',
        vehicle_battery_data: 'Exakt spårbar batteridata för fordon',
    },
    // 斯洛伐克
    skSK: {
        factory: 'Továreň',
        vehicle_platform: 'Platforma vozidla',
        model_year: 'Rok modelu',
        order_no: 'Číslo objednávky',
        order_type: 'Typ objednávky',
        vehicle_material_no: 'Materiálové číslo celého vozidla',
        engine_no: 'Sériové číslo motora',
        certificate_no_14: '14-miestne číslo certifikátu',
        certificate_no_15: '15-miestne číslo certifikátu',
        certificate_date: 'Dátum tlače certifikátu',
        pn: 'PIN',
        uptime: 'Čas vstupu do záverečnej montáže',
        end_time: 'Čas ukončenia výroby vozidla',
        bomversion: 'BOMVERSION',
        product_code: 'Výrobný kód',
        industrial_division: 'Rozdelenie výroby (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Popis materiálového čísla celého vozidla',
        SAIC_order_number: 'Medzinárodné číslo objednávky SAIC',
        station_code: 'Kód továrne',
        station_desc: 'Popis továrne',
        station_number: 'Číslo pracoviska',
        station_name: 'Názov pracoviska',
        vehicle_arrival_time: 'Čas príchodu vozidla',
        key_component_barcode: 'Čiarový kód kľúčovej súčasti',
        scan_time: 'Čas skenovania',
        key_component_type_code: 'Kód typu kľúčovej súčasti',
        key_component_type_desc: 'Popis typu kľúčovej súčasti (čínsky)',
        key_component_type_descen: 'Popis typu kľúčovej súčasti (anglicky)',
        part_number: 'Číslo dielu',
        supplier_name: 'Názov dodávateľa',
        traceability_number: 'Číslo sledovateľnosti',
        subcritical_component_type: 'Typ podkľúčovej súčasti',
        batch_number: 'Číslo šarže',
        vehicle_base_info: 'Základné informácie o vozidle',
        vehicle_crossing_data: 'Údaje o prechode vozidla bodmi',
        accurately_traceable_parts_list: 'Zoznam presne sledovateľných dielov',
        vehicle_configuration_information: 'Informácie o konfigurácii vozidla',
        VIN: 'VIN',
        SAP_feature_ID: 'ID SAP atribútu',
        SAP_feature_Codes: 'Kódy SAP atribútu',
        SAP_feature_Description: 'Popis SAP atribútu',
        SAP_feature_value_Description: 'Popis hodnoty SAP atribútu',
        SAP_feature_Description_EN: 'Popis SAP atribútu (anglicky)',
        SAP_feature_value_Description_EN: 'Popis hodnoty SAP atribútu (anglicky)',
        batteryNo: 'Číslo batérie',
        qmotorNo: 'Číslo predného motora',
        hmotorNo: 'Číslo zadného motora',
        feature_ID: 'ID atribútu',
        feature_Description: 'Popis atribútu (čínsky)',
        feature_Description_EN: 'Popis atribútu (anglicky)',
        feature_Codes: 'Kód atribútu',
        feature_value_Description: 'Popis hodnoty atribútu (čínsky)',
        feature_value_Description_EN: 'Popis hodnoty atribútu (anglicky)',
        description_zh: 'Popis v čínštine',
        supplier: 'Dodávateľ',
        barCoding: 'Čiarové kódovanie',
        key_component_type_desc_En: 'Popis typu kľúčovej súčasti (anglicky)',
        partName: 'Názov dielu (čínsky)',
        partName_En: 'Názov dielu (anglicky)',
        workstation_code: 'Kód pracoviska',
        workstationDesc: 'Popis pracoviska (čínsky)',
        workstationDesc_En: 'Popis pracoviska (anglicky)',
        packageNo: 'Kód batériového balíka',
        packageType: 'Model batériového balíka',
        moduleNo: 'Kód batériového modulu',
        moduleType: 'Model modulu',
        cellNo: 'Kód jednotlivej článku',
        cellModelId: 'Model článku',
        uploadTime: 'Čas nahratia',
        vehicle_battery_data: 'Presne sledovateľné údaje o batérii vozidla',
    },
    // 斯洛文尼亚
    slSI: {
        factory: 'Tovarna',
        vehicle_platform: 'Platforma vozila',
        model_year: 'Letnik modela',
        order_no: 'Številka naročila',
        order_type: 'Vrsta naročila',
        vehicle_material_no: 'Materialna številka celotnega vozila',
        engine_no: 'Serijska številka motorja',
        certificate_no_14: '14-mestna številka potrdila',
        certificate_no_15: '15-mestna številka potrdila',
        certificate_date: 'Datum tiskanja potrdila',
        pn: 'PIN',
        uptime: 'Čas vstopa v končno montažo',
        end_time: 'Čas zaključka proizvodnje vozila',
        bomversion: 'BOMVERSION',
        product_code: 'Proizvodna koda',
        industrial_division: 'Razvrstitev proizvodnje (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Opis materialne številke celotnega vozila',
        SAIC_order_number: 'Mednarodna številka naročila SAIC',
        station_code: 'Koda tovarne',
        station_desc: 'Opis tovarne',
        station_number: 'Številka delovnega mesta',
        station_name: 'Ime delovnega mesta',
        vehicle_arrival_time: 'Čas prihoda vozila',
        key_component_barcode: 'Črtna koda ključne komponente',
        scan_time: 'Čas branja',
        key_component_type_code: 'Koda vrste ključne komponente',
        key_component_type_desc: 'Opis vrste ključne komponente (kitajsko)',
        key_component_type_descen: 'Opis vrste ključne komponente (angleško)',
        part_number: 'Številka dela',
        supplier_name: 'Ime dobavitelja',
        traceability_number: 'Številka sledljivosti',
        subcritical_component_type: 'Vrsta podključne komponente',
        batch_number: 'Številka serije',
        vehicle_base_info: 'Osnovni podatki o vozilu',
        vehicle_crossing_data: 'Podatki o prehodu vozila skozi točke',
        accurately_traceable_parts_list: 'Seznam natančno sledljivih delov',
        vehicle_configuration_information: 'Informacije o konfiguraciji vozila',
        VIN: 'VIN',
        SAP_feature_ID: 'ID značilnosti SAP',
        SAP_feature_Codes: 'Kode značilnosti SAP',
        SAP_feature_Description: 'Opis značilnosti SAP',
        SAP_feature_value_Description: 'Opis vrednosti značilnosti SAP',
        SAP_feature_Description_EN: 'Opis značilnosti SAP (angleško)',
        SAP_feature_value_Description_EN: 'Opis vrednosti značilnosti SAP (angleško)',
        batteryNo: 'Številka baterije',
        qmotorNo: 'Številka sprednjega motorja',
        hmotorNo: 'Številka zadnjega motorja',
        feature_ID: 'ID značilnosti',
        feature_Description: 'Opis značilnosti (kitajsko)',
        feature_Description_EN: 'Opis značilnosti (angleško)',
        feature_Codes: 'Koda značilnosti',
        feature_value_Description: 'Opis vrednosti značilnosti (kitajsko)',
        feature_value_Description_EN: 'Opis vrednosti značilnosti (angleško)',
        description_zh: 'Opis v kitajščini',
        supplier: 'Dobavitelj',
        barCoding: 'Črtno kodiranje',
        key_component_type_desc_En: 'Opis vrste ključne komponente (angleško)',
        partName: 'Ime dela (kitajsko)',
        partName_En: 'Ime dela (angleško)',
        workstation_code: 'Koda delovnega mesta',
        workstationDesc: 'Opis delovnega mesta (kitajsko)',
        workstationDesc_En: 'Opis delovnega mesta (angleško)',
        packageNo: 'Koda baterijskega paketa',
        packageType: 'Model baterijskega paketa',
        moduleNo: 'Koda baterijskega modula',
        moduleType: 'Model modula',
        cellNo: 'Koda posamezne celice',
        cellModelId: 'Model celice',
        uploadTime: 'Čas nalaganja',
        vehicle_battery_data: 'Natančno sledljivi podatki o bateriji vozila',
    },
    // 泰语
    thTH: {
        factory: 'โรงงาน',
        vehicle_platform: 'แพลตฟอร์มยานพาหนะ',
        model_year: 'ปีรุ่น',
        order_no: 'เลขที่คำสั่งซื้อ',
        order_type: 'ประเภทคำสั่งซื้อ',
        vehicle_material_no: 'หมายเลขวัสดุยานพาหนะทั้งคัน',
        engine_no: 'หมายเลขเครื่องยนต์',
        certificate_no_14: 'หมายเลขใบรับรอง 14 หลัก',
        certificate_no_15: 'หมายเลขใบรับรอง 15 หลัก',
        certificate_date: 'วันที่พิมพ์ใบรับรอง',
        pn: 'PIN',
        uptime: 'เวลาเริ่มสายการประกอบขั้นสุดท้าย',
        end_time: 'เวลาสิ้นสุดการผลิตยานพาหนะ',
        bomversion: 'BOMVERSION',
        product_code: 'รหัสการผลิต',
        industrial_division: 'การจัดกลุ่มการผลิต (CKD, SKD, CBU)',
        vehicle_material_number_description: 'คำอธิบายหมายเลขวัสดุยานพาหนะทั้งคัน',
        SAIC_order_number: 'หมายเลขคำสั่งซื้อระหว่างประเทศของ SAIC',
        station_code: 'รหัสโรงงาน',
        station_desc: 'คำอธิบายโรงงาน',
        station_number: 'หมายเลขสถานีงาน',
        station_name: 'ชื่อสถานีงาน',
        vehicle_arrival_time: 'เวลาที่ยานพาหนะมาถึง',
        key_component_barcode: 'บาร์โค้ดชิ้นส่วนสำคัญ',
        scan_time: 'เวลาสแกน',
        key_component_type_code: 'รหัสประเภทชิ้นส่วนสำคัญ',
        key_component_type_desc: 'คำอธิบายประเภทชิ้นส่วนสำคัญ (ภาษาจีน)',
        key_component_type_descen: 'คำอธิบายประเภทชิ้นส่วนสำคัญ (ภาษาอังกฤษ)',
        part_number: 'หมายเลขชิ้นส่วน',
        supplier_name: 'ชื่อผู้จัดจำหน่าย',
        traceability_number: 'หมายเลขติดตามย้อนกลับ',
        subcritical_component_type: 'ประเภทย่อยชิ้นส่วนสำคัญ',
        batch_number: 'หมายเลขล็อต',
        vehicle_base_info: 'ข้อมูลพื้นฐานของยานพาหนะ',
        vehicle_crossing_data: 'ข้อมูลการผ่านจุดของยานพาหนะ',
        accurately_traceable_parts_list: 'รายการชิ้นส่วนที่ติดตามได้อย่างแม่นยำ',
        vehicle_configuration_information: 'ข้อมูลการกำหนดค่ายานพาหนะ',
        VIN: 'VIN',
        SAP_feature_ID: 'รหัสคุณลักษณะ SAP',
        SAP_feature_Codes: 'รหัสคุณลักษณะ SAP',
        SAP_feature_Description: 'คำอธิบายคุณลักษณะ SAP',
        SAP_feature_value_Description: 'คำอธิบายค่าคุณลักษณะ SAP',
        SAP_feature_Description_EN: 'คำอธิบายคุณลักษณะ SAP (ภาษาอังกฤษ)',
        SAP_feature_value_Description_EN: 'คำอธิบายค่าคุณลักษณะ SAP (ภาษาอังกฤษ)',
        batteryNo: 'หมายเลขแบตเตอรี่',
        qmotorNo: 'หมายเลขมอเตอร์หน้า',
        hmotorNo: 'หมายเลขมอเตอร์หลัง',
        feature_ID: 'รหัสคุณลักษณะ',
        feature_Description: 'คำอธิบายคุณลักษณะ (ภาษาจีน)',
        feature_Description_EN: 'คำอธิบายคุณลักษณะ (ภาษาอังกฤษ)',
        feature_Codes: 'รหัสคุณลักษณะ',
        feature_value_Description: 'คำอธิบายค่าคุณลักษณะ (ภาษาจีน)',
        feature_value_Description_EN: 'คำอธิบายค่าคุณลักษณะ (ภาษาอังกฤษ)',
        description_zh: 'คำอธิบายเป็นภาษาจีน',
        supplier: 'ผู้จัดจำหน่าย',
        barCoding: 'การเข้ารหัสบาร์โค้ด',
        key_component_type_desc_En: 'คำอธิบายประเภทชิ้นส่วนสำคัญ (ภาษาอังกฤษ)',
        partName: 'ชื่อชิ้นส่วน (ภาษาจีน)',
        partName_En: 'ชื่อชิ้นส่วน (ภาษาอังกฤษ)',
        workstation_code: 'รหัสสถานีงาน',
        workstationDesc: 'คำอธิบายสถานีงาน (ภาษาจีน)',
        workstationDesc_En: 'คำอธิบายสถานีงาน (ภาษาอังกฤษ)',
        packageNo: 'รหัสแพ็กแบตเตอรี่',
        packageType: 'รุ่นแพ็กแบตเตอรี่',
        moduleNo: 'รหัสโมดูลแบตเตอรี่',
        moduleType: 'รุ่นโมดูล',
        cellNo: 'รหัสเซลล์แบตเตอรี่',
        cellModelId: 'รุ่นเซลล์',
        uploadTime: 'เวลาอัปโหลด',
        vehicle_battery_data: 'ข้อมูลแบตเตอรี่ยานพาหนะที่ติดตามได้อย่างแม่นยำ',
    },
    // 乌克兰语
    ukUA: {
        factory: 'Завод',
        vehicle_platform: 'Платформа транспортного засобу',
        model_year: 'Рік моделі',
        order_no: 'Номер замовлення',
        order_type: 'Тип замовлення',
        vehicle_material_no: 'Номер матеріалу повного транспортного засобу',
        engine_no: 'Серійний номер двигуна',
        certificate_no_14: '14-значний номер сертифіката',
        certificate_no_15: '15-значний номер сертифіката',
        certificate_date: 'Дата друку сертифіката',
        pn: 'PIN',
        uptime: 'Час початку фінішної збірки',
        end_time: 'Час завершення виробництва транспортного засобу',
        bomversion: 'BOMVERSION',
        product_code: 'Код виробництва',
        industrial_division: 'Класифікація виробництва (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Опис номера матеріалу повного ТЗ',
        SAIC_order_number: 'Міжнародний номер замовлення SAIC',
        station_code: 'Код заводу',
        station_desc: 'Опис заводу',
        station_number: 'Номер робочого місця',
        station_name: 'Назва робочого місця',
        vehicle_arrival_time: 'Час прибуття транспортного засобу',
        key_component_barcode: 'Штрихкод ключової компоненти',
        scan_time: 'Час сканування',
        key_component_type_code: 'Код типу ключової компоненти',
        key_component_type_desc: 'Опис типу ключової компоненти (китайською)',
        key_component_type_descen: 'Опис типу ключової компоненти (англійською)',
        part_number: 'Номер деталі',
        supplier_name: 'Ім\'я постачальника',
        traceability_number: 'Номер прослежуваності',
        subcritical_component_type: 'Тип підключової компоненти',
        batch_number: 'Номер партії',
        vehicle_base_info: 'Базова інформація про транспортний засіб',
        vehicle_crossing_data: 'Дані про проходження ТЗ через точки',
        accurately_traceable_parts_list: 'Перелік точно прослежуваних деталей',
        vehicle_configuration_information: 'Інформація про конфігурацію ТЗ',
        VIN: 'VIN',
        SAP_feature_ID: 'ID ознаки SAP',
        SAP_feature_Codes: 'Коди ознаки SAP',
        SAP_feature_Description: 'Опис ознаки SAP',
        SAP_feature_value_Description: 'Опис значення ознаки SAP',
        SAP_feature_Description_EN: 'Опис ознаки SAP (англійською)',
        SAP_feature_value_Description_EN: 'Опис значення ознаки SAP (англійською)',
        batteryNo: 'Номер акумулятора',
        qmotorNo: 'Номер переднього двигуна',
        hmotorNo: 'Номер заднього двигуна',
        feature_ID: 'ID ознаки',
        feature_Description: 'Опис ознаки (китайською)',
        feature_Description_EN: 'Опис ознаки (англійською)',
        feature_Codes: 'Код ознаки',
        feature_value_Description: 'Опис значення ознаки (китайською)',
        feature_value_Description_EN: 'Опис значення ознаки (англійською)',
        description_zh: 'Опис китайською мовою',
        supplier: 'Постачальник',
        barCoding: 'Штрихкодування',
        key_component_type_desc_En: 'Опис типу ключової компоненти (англійською)',
        partName: 'Назва деталі (китайською)',
        partName_En: 'Назва деталі (англійською)',
        workstation_code: 'Код робочого місця',
        workstationDesc: 'Опис робочого місця (китайською)',
        workstationDesc_En: 'Опис робочого місця (англійською)',
        packageNo: 'Код батарейного пакета',
        packageType: 'Модель батарейного пакета',
        moduleNo: 'Код батарейного модуля',
        moduleType: 'Модель модуля',
        cellNo: 'Код окремої комірки',
        cellModelId: 'Модель комірки',
        uploadTime: 'Час завантаження',
        vehicle_battery_data: 'Точно прослежувані дані про акумулятор ТЗ',
    },
    // 希腊语
    elGR: {
        factory: 'Εργοστάσιο',
        vehicle_platform: 'Πλατφόρμα οχήματος',
        model_year: 'Έτος μοντέλου',
        order_no: 'Αριθμός παραγγελίας',
        order_type: 'Τύπος παραγγελίας',
        vehicle_material_no: 'Αριθμός υλικού ολόκληρου του οχήματος',
        engine_no: 'Αριθμός κινητήρα',
        certificate_no_14: '14-ψήφιος αριθμός πιστοποιητικού',
        certificate_no_15: '15-ψήφιος αριθμός πιστοποιητικού',
        certificate_date: 'Ημερομηνία εκτύπωσης πιστοποιητικού',
        pn: 'PIN',
        uptime: 'Ώρα εισόδου στη γραμμή τελικής συναρμολόγησης',
        end_time: 'Ώρα ολοκλήρωσης παραγωγής οχήματος',
        bomversion: 'BOMVERSION',
        product_code: 'Κωδικός παραγωγής',
        industrial_division: 'Ταξινόμηση παραγωγής (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Περιγραφή αριθμού υλικού ολόκληρου του οχήματος',
        SAIC_order_number: 'Διεθνής αριθμός παραγγελίας SAIC',
        station_code: 'Κωδικός εργοστασίου',
        station_desc: 'Περιγραφή εργοστασίου',
        station_number: 'Αριθμός σταθμού εργασίας',
        station_name: 'Όνομα σταθμού εργασίας',
        vehicle_arrival_time: 'Ώρα άφιξης οχήματος',
        key_component_barcode: 'Γραμμωτός κώδικας βασικού εξαρτήματος',
        scan_time: 'Ώρα σάρωσης',
        key_component_type_code: 'Κωδικός τύπου βασικού εξαρτήματος',
        key_component_type_desc: 'Περιγραφή τύπου βασικού εξαρτήματος (κινεζικά)',
        key_component_type_descen: 'Περιγραφή τύπου βασικού εξαρτήματος (αγγλικά)',
        part_number: 'Αριθμός εξαρτήματος',
        supplier_name: 'Όνομα προμηθευτή',
        traceability_number: 'Αριθμός ιχνηλασιμότητας',
        subcritical_component_type: 'Υποτύπος βασικού εξαρτήματος',
        batch_number: 'Αριθμός παρτίδας',
        vehicle_base_info: 'Βασικές πληροφορίες οχήματος',
        vehicle_crossing_data: 'Δεδομένα διέλευσης οχήματος από σημεία',
        accurately_traceable_parts_list: 'Λίστα ακριβώς ιχνηλάσιμων εξαρτημάτων',
        vehicle_configuration_information: 'Πληροφορίες διαμόρφωσης οχήματος',
        VIN: 'VIN',
        SAP_feature_ID: 'Αναγνωριστικό χαρακτηριστικού SAP',
        SAP_feature_Codes: 'Κωδικοί χαρακτηριστικού SAP',
        SAP_feature_Description: 'Περιγραφή χαρακτηριστικού SAP',
        SAP_feature_value_Description: 'Περιγραφή τιμής χαρακτηριστικού SAP',
        SAP_feature_Description_EN: 'Περιγραφή χαρακτηριστικού SAP (αγγλικά)',
        SAP_feature_value_Description_EN: 'Περιγραφή τιμής χαρακτηριστικού SAP (αγγλικά)',
        batteryNo: 'Αριθμός μπαταρίας',
        qmotorNo: 'Αριθμός εμπρόσθιου κινητήρα',
        hmotorNo: 'Αριθμός οπίσθιου κινητήρα',
        feature_ID: 'Αναγνωριστικό χαρακτηριστικού',
        feature_Description: 'Περιγραφή χαρακτηριστικού (κινεζικά)',
        feature_Description_EN: 'Περιγραφή χαρακτηριστικού (αγγλικά)',
        feature_Codes: 'Κωδικός χαρακτηριστικού',
        feature_value_Description: 'Περιγραφή τιμής χαρακτηριστικού (κινεζικά)',
        feature_value_Description_EN: 'Περιγραφή τιμής χαρακτηριστικού (αγγλικά)',
        description_zh: 'Περιγραφή στα κινεζικά',
        supplier: 'Προμηθευτής',
        barCoding: 'Κωδικοποίηση γραμμωτού κώδικα',
        key_component_type_desc_En: 'Περιγραφή τύπου βασικού εξαρτήματος (αγγλικά)',
        partName: 'Όνομα εξαρτήματος (κινεζικά)',
        partName_En: 'Όνομα εξαρτήματος (αγγλικά)',
        workstation_code: 'Κωδικός σταθμού εργασίας',
        workstationDesc: 'Περιγραφή σταθμού εργασίας (κινεζικά)',
        workstationDesc_En: 'Περιγραφή σταθμού εργασίας (αγγλικά)',
        packageNo: 'Κωδικός πακέτου μπαταρίας',
        packageType: 'Μοντέλο πακέτου μπαταρίας',
        moduleNo: 'Κωδικός ενότητας μπαταρίας',
        moduleType: 'Μοντέλο ενότητας',
        cellNo: 'Κωδικός μεμονωμένου στοιχείου',
        cellModelId: 'Μοντέλο στοιχείου',
        uploadTime: 'Ώρα ανέβασματος',
        vehicle_battery_data: 'Ακριβώς ιχνηλάσιμα δεδομένα μπαταρίας οχήματος',
    },
    // 爱沙尼亚
    etEE: {
        factory: 'Tehas',
        vehicle_platform: 'Sõiduki platvorm',
        model_year: 'Mudeliaasta',
        order_no: 'Tellimuse number',
        order_type: 'Tellimuse tüüp',
        vehicle_material_no: 'Täissõiduki materjali number',
        engine_no: 'Mootori seerianumber',
        certificate_no_14: '14-kohaline sertifikaadinumber',
        certificate_no_15: '15-kohaline sertifikaadinumber',
        certificate_date: 'Sertifikaadi trükkimise kuupäev',
        pn: 'PIN',
        uptime: 'Lõpliku koosteliini alustamise aeg',
        end_time: 'Sõiduki tootmise lõpetamise aeg',
        bomversion: 'BOMVERSION',
        product_code: 'Tootekood',
        industrial_division: 'Tootja liigitus (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Täissõiduki materjali numbri kirjeldus',
        SAIC_order_number: 'SAIC rahvusvaheline tellimuse number',
        station_code: 'Tehase kood',
        station_desc: 'Tehase kirjeldus',
        station_number: 'Tööjaama number',
        station_name: 'Tööjaama nimi',
        vehicle_arrival_time: 'Sõiduki saabumisaeg',
        key_component_barcode: 'Põhikomponendi vöötkood',
        scan_time: 'Skaneerimise aeg',
        key_component_type_code: 'Põhikomponendi tüübi kood',
        key_component_type_desc: 'Põhikomponendi tüübi kirjeldus (hiina keeles)',
        key_component_type_descen: 'Põhikomponendi tüübi kirjeldus (inglise keeles)',
        part_number: 'Osa number',
        supplier_name: 'Tarnija nimi',
        traceability_number: 'Jälitavuse number',
        subcritical_component_type: 'Alampõhikomponendi tüüp',
        batch_number: 'Partii number',
        vehicle_base_info: 'Sõiduki põhiandmed',
        vehicle_crossing_data: 'Sõiduki läbimise andmed',
        accurately_traceable_parts_list: 'Täpselt jälitavate osade loend',
        vehicle_configuration_information: 'Sõiduki konfiguratsiooni teave',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP funktsiooni ID',
        SAP_feature_Codes: 'SAP funktsiooni koodid',
        SAP_feature_Description: 'SAP funktsiooni kirjeldus',
        SAP_feature_value_Description: 'SAP funktsiooni väärtuse kirjeldus',
        SAP_feature_Description_EN: 'SAP funktsiooni kirjeldus (inglise keeles)',
        SAP_feature_value_Description_EN: 'SAP funktsiooni väärtuse kirjeldus (inglise keeles)',
        batteryNo: 'Akunumber',
        qmotorNo: 'Esiosa mootori number',
        hmotorNo: 'Tagumise mootori number',
        feature_ID: 'Funktsiooni ID',
        feature_Description: 'Funktsiooni kirjeldus (hiina keeles)',
        feature_Description_EN: 'Funktsiooni kirjeldus (inglise keeles)',
        feature_Codes: 'Funktsiooni kood',
        feature_value_Description: 'Funktsiooni väärtuse kirjeldus (hiina keeles)',
        feature_value_Description_EN: 'Funktsiooni väärtuse kirjeldus (inglise keeles)',
        description_zh: 'Kirjeldus hiina keeles',
        supplier: 'Tarnija',
        barCoding: 'Vöötkoodimine',
        key_component_type_desc_En: 'Põhikomponendi tüübi kirjeldus (inglise keeles)',
        partName: 'Osa nimi (hiina keeles)',
        partName_En: 'Osa nimi (inglise keeles)',
        workstation_code: 'Tööjaama kood',
        workstationDesc: 'Tööjaama kirjeldus (hiina keeles)',
        workstationDesc_En: 'Tööjaama kirjeldus (inglise keeles)',
        packageNo: 'Aku paki kood',
        packageType: 'Aku paki mudel',
        moduleNo: 'Aku mooduli kood',
        moduleType: 'Mooduli mudel',
        cellNo: 'Üksiku aku elemendi kood',
        cellModelId: 'Elemendi mudel',
        uploadTime: 'Üleslaadimise aeg',
        vehicle_battery_data: 'Sõiduki täpselt jälitavad akuandmed',
    },
    // 哈萨克
    kkKZ: {
        factory: 'Зауыт',
        vehicle_platform: 'Көлік платформасы',
        model_year: 'Модель жылы',
        order_no: 'Тапсырыс нөмірі',
        order_type: 'Тапсырыс түрі',
        vehicle_material_no: 'Толық көлік материалдарының нөмірі',
        engine_no: 'Қозғалтқыш нөмірі',
        certificate_no_14: '14 таңбалы сертификат нөмірі',
        certificate_no_15: '15 таңбалы сертификат нөмірі',
        certificate_date: 'Сертификатты басып шығару күні',
        pn: 'PIN',
        uptime: 'Ақырғы жинақтау желісіне ену уақыты',
        end_time: 'Көлікті шығару аяқталу уақыты',
        bomversion: 'BOMVERSION',
        product_code: 'Өндіру коды',
        industrial_division: 'Өндіру классификациясы (CKD, SKD, CBU)',
        vehicle_material_number_description: 'Толық көлік материалдары нөмірінің сипаттамасы',
        SAIC_order_number: 'SAIC халықаралық тапсырыс нөмірі',
        station_code: 'Зауыт коды',
        station_desc: 'Зауыт сипаттамасы',
        station_number: 'Жұмыс орнының нөмірі',
        station_name: 'Жұмыс орнының атауы',
        vehicle_arrival_time: 'Көліктің келу уақыты',
        key_component_barcode: 'Негізгі бөлшектің штрих-коды',
        scan_time: 'Сканерлеу уақыты',
        key_component_type_code: 'Негізгі бөлшек түрінің коды',
        key_component_type_desc: 'Негізгі бөлшек түрінің сипаттамасы (қытай тілінде)',
        key_component_type_descen: 'Негізгі бөлшек түрінің сипаттамасы (ағылшын тілінде)',
        part_number: 'Бөлшек нөмірі',
        supplier_name: 'Жеткізушінің аты',
        traceability_number: 'Бақылау нөмірі',
        subcritical_component_type: 'Қосалқы негізгі бөлшек түрі',
        batch_number: 'Партия нөмірі',
        vehicle_base_info: 'Көлік туралы негізгі ақпарат',
        vehicle_crossing_data: 'Көліктің нүктелер арқылы өту деректері',
        accurately_traceable_parts_list: 'Дәл бақыланатын бөлшектер тізімі',
        vehicle_configuration_information: 'Көлік конфигурациясы туралы ақпарат',
        VIN: 'VIN',
        SAP_feature_ID: 'SAP қасиетінің ID-і',
        SAP_feature_Codes: 'SAP қасиетінің кодтары',
        SAP_feature_Description: 'SAP қасиетінің сипаттамасы',
        SAP_feature_value_Description: 'SAP қасиетінің мәнінің сипаттамасы',
        SAP_feature_Description_EN: 'SAP қасиетінің сипаттамасы (ағылшын тілінде)',
        SAP_feature_value_Description_EN: 'SAP қасиетінің мәнінің сипаттамасы (ағылшын тілінде)',
        batteryNo: 'Аккумулятор нөмірі',
        qmotorNo: 'Алдыңғы қозғалтқыш нөмірі',
        hmotorNo: 'Артқы қозғалтқыш нөмірі',
        feature_ID: 'Қасиет ID-і',
        feature_Description: 'Қасиет сипаттамасы (қытай тілінде)',
        feature_Description_EN: 'Қасиет сипаттамасы (ағылшын тілінде)',
        feature_Codes: 'Қасиет коды',
        feature_value_Description: 'Қасиет мәнінің сипаттамасы (қытай тілінде)',
        feature_value_Description_EN: 'Қасиет мәнінің сипаттамасы (ағылшын тілінде)',
        description_zh: 'Қытай тіліндегі сипаттама',
        supplier: 'Жеткізуші',
        barCoding: 'Штрих-кодтау',
        key_component_type_desc_En: 'Негізгі бөлшек түрінің сипаттамасы (ағылшын тілінде)',
        partName: 'Бөлшек атауы (қытай тілінде)',
        partName_En: 'Бөлшек атауы (ағылшын тілінде)',
        workstation_code: 'Жұмыс орнының коды',
        workstationDesc: 'Жұмыс орнының сипаттамасы (қытай тілінде)',
        workstationDesc_En: 'Жұмыс орнының сипаттамасы (ағылшын тілінде)',
        packageNo: 'Аккумулятор пакетінің коды',
        packageType: 'Аккумулятор пакетінің моделі',
        moduleNo: 'Аккумулятор модулінің коды',
        moduleType: 'Модуль моделі',
        cellNo: 'Жеке элемент коды',
        cellModelId: 'Элемент моделі',
        uploadTime: 'Жүктеу уақыты',
        vehicle_battery_data: 'Көлік аккумуляторының дәл бақыланатын деректері',
    },
    // 希伯来语
    heIL: {
        factory: 'מפעל',
        vehicle_platform: 'פלטפורמת רכב',
        model_year: 'שנת דגם',
        order_no: 'מספר הזמנה',
        order_type: 'סוג הזמנה',
        vehicle_material_no: 'מספר חומר של הרכב השלם',
        engine_no: 'מספר מנוע',
        certificate_no_14: 'מספר תעודת התאמה בן 14 ספרות',
        certificate_no_15: 'מספר תעודת התאמה בן 15 ספרות',
        certificate_date: 'תאריך הדפסת תעודה',
        pn: 'PIN',
        uptime: 'זמן כניסת קו ההרכבה הסופית',
        end_time: 'זמן סיום ייצור הרכב',
        bomversion: 'BOMVERSION',
        product_code: 'קוד ייצור',
        industrial_division: 'סיווג ייצור (CKD, SKD, CBU)',
        vehicle_material_number_description: 'תיאור מספר חומר של הרכב השלם',
        SAIC_order_number: 'מספר הזמנה בינלאומי של SAIC',
        station_code: 'קוד מפעל',
        station_desc: 'תיאור מפעל',
        station_number: 'מספר תחנת עבודה',
        station_name: 'שם תחנת עבודה',
        vehicle_arrival_time: 'זמן הגעת הרכב',
        key_component_barcode: 'ברקוד רכיב מפתח',
        scan_time: 'זמן סריקת הברקוד',
        key_component_type_code: 'קוד סוג רכיב מפתח',
        key_component_type_desc: 'תיאור סוג רכיב מפתח (בסינית)',
        key_component_type_descen: 'תיאור סוג רכיב מפתח (באנגלית)',
        part_number: 'מספר חלק',
        supplier_name: 'שם הספק',
        traceability_number: 'מספר זיקה',
        subcritical_component_type: 'תת סוג רכיב מפתח',
        batch_number: 'מספר אצווה',
        vehicle_base_info: 'מידע בסיסי על הרכב',
        vehicle_crossing_data: 'נתוני מעבר נקודות של הרכב',
        accurately_traceable_parts_list: 'רשימת חלקים ניתנים לזיהוי מדויק',
        vehicle_configuration_information: 'מידע על תצורת הרכב',
        VIN: 'VIN',
        SAP_feature_ID: 'מזהה מאפיין SAP',
        SAP_feature_Codes: 'קודי מאפיין SAP',
        SAP_feature_Description: 'תיאור מאפיין SAP',
        SAP_feature_value_Description: 'תיאור ערך מאפיין SAP',
        SAP_feature_Description_EN: 'תיאור מאפיין SAP (באנגלית)',
        SAP_feature_value_Description_EN: 'תיאור ערך מאפיין SAP (באנגלית)',
        batteryNo: 'מספר סוללה',
        qmotorNo: 'מספר מנוע קדמי',
        hmotorNo: 'מספר מנוע אחורי',
        feature_ID: 'מזהה מאפיין',
        feature_Description: 'תיאור מאפיין (בסינית)',
        feature_Description_EN: 'תיאור מאפיין (באנגלית)',
        feature_Codes: 'קוד מאפיין',
        feature_value_Description: 'תיאור ערך מאפיין (בסינית)',
        feature_value_Description_EN: 'תיאור ערך מאפיין (באנגלית)',
        description_zh: 'תיאור בסינית',
        supplier: 'ספק',
        barCoding: 'קידוד ברקוד',
        key_component_type_desc_En: 'תיאור סוג רכיב מפתח (באנגלית)',
        partName: 'שם חלק (בסינית)',
        partName_En: 'שם חלק (באנגלית)',
        workstation_code: 'קוד תחנת עבודה',
        workstationDesc: 'תיאור תחנת עבודה (בסינית)',
        workstationDesc_En: 'תיאור תחנת עבודה (באנגלית)',
        packageNo: 'קוד חבילת סוללה',
        packageType: 'דגם חבילת סוללה',
        moduleNo: 'קוד מודול סוללה',
        moduleType: 'דגם מודול',
        cellNo: 'קוד תא סוללה',
        cellModelId: 'דגם תא',
        uploadTime: 'זמן העלאה',
        vehicle_battery_data: 'נתוני סוללה ניתנים לזיהוי מדויק של הרכב',
    },
};
